<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-cubes mr-2" />Inventory</h5>
            <hr />
            <b-row>
                <b-col md="8">
                    <div class="d-flex">
                        <b-input-group>
                            <b-input-group-prepend>
                                <b-button variant="dark" @click="showModalFilter">
                                    <i class="fa fa-search mr-2" />Filter...
                                </b-button>
                            </b-input-group-prepend>
                            <b-form-input
                                v-model="filter.noFaktur"
                                maxlength="50"
                                placeholder="Cari No. Faktur..."
                                @keydown.enter="changeFilter()"
                            />
                        </b-input-group>
                        <b-input-group class="ml-2">
                            <b-form-input
                                v-model="filter.imeiSn"
                                maxlength="50"
                                placeholder="Cari No. Imei..."
                                @keydown.enter="changeFilter()"
                            />
                            <b-input-group-append>
                                <b-button
                                    variant="primary"
                                    @click="changeFilter()"
                                    >Cari</b-button
                                >
                            </b-input-group-append>
                        </b-input-group>
                        <b-button
                            class="ml-2"
                            variant="danger"
                            @click="resetFilter"
                        >
                            Reset
                        </b-button>
                    </div>
                </b-col>
                <b-col md="4" class="text-right">
                    <b-dropdown
                        v-if="isDownloadExcelAllowed"
                        variant="success"
                        id="dropdown-download-excel"
                    >
                        <template #button-content>
                            <i class="fa fa-download mr-2"></i> Download Excel
                        </template>
                        <b-dropdown-item-button @click="downloadExcelStock"
                            >Stock Barang</b-dropdown-item-button
                        >
                        <b-dropdown-item-button
                            @click="downloadExcelStockSimple"
                            >Stock Barang (Simple)</b-dropdown-item-button
                        >
                        <b-dropdown-item-button @click="downloadExcelDraft"
                            >Draft</b-dropdown-item-button
                        >
                        <b-dropdown-item-button @click="downloadMarketplace"
                            >Marketplace</b-dropdown-item-button
                        >
                        <b-dropdown-item-button
                            @click="downloadExcelAccessories"
                            >Aksesoris</b-dropdown-item-button
                        >
                    </b-dropdown>
                </b-col>
            </b-row>
            <template v-if="initTable">
                <b-table
                    bordered
                    hover
                    show-empty
                    no-local-sorting
                    :busy="isBusy"
                    :items="items"
                    :fields="fields"
                    @sort-changed="onSortChanged"
                    responsive
                    class="my-3"
                >
                    <template v-slot:empty>
                        Tidak ada data inventory.
                    </template>
                    <template v-slot:cell(item)="row">
                        {{ row.item.type }}
                        <span v-if="row.item.item_year != null"
                            >({{ row.item.item_year }})</span
                        >
                        <div class="small" v-if="row.item.color_id != null">
                            {{ row.item.kind }} - {{ row.item.brand }} -
                            {{ row.item.color }}<br />
                            NF
                            <strong
                                style="cursor:pointer;"
                                @click="copyToClipboard(row.item.no_faktur_pgi)"
                                >{{ row.item.no_faktur_pgi }}</strong
                            >
                            <i
                                style="cursor:pointer;"
                                @click="copyToClipboard(row.item.no_faktur_pgi)"
                                class="fa fa-fw fa-copy"
                            /><br />
                            IMEI
                            <strong
                                style="cursor:pointer;"
                                @click="copyToClipboard(row.item.imei_sn)"
                                >{{ row.item.imei_sn }}
                            </strong>
                            <i
                                style="cursor:pointer;"
                                @click="copyToClipboard(row.item.imei_sn)"
                                class="fa fa-fw fa-copy"
                            />
                        </div>
                        <div class="small" v-else>
                            {{ row.item.kind }} - {{ row.item.brand }}<br />
                            NF <strong>{{ row.item.no_faktur_pgi }}</strong
                            ><br />
                            IMEI {{ row.item.imei_sn }}
                        </div>
                    </template>
                    <template v-slot:cell(price)="row">
                        <!-- Rp. {{ $helper.formatThousand(row.item.final_price) }} -->
                        <!-- Rp. {{ $helper.formatThousand(row.item.final_price_after_adj) }} -->
                        Rp.
                        {{
                            $helper.formatThousand(
                                row.item.final_price_after_segment
                            )
                        }}
                        <div class="small">
                            Harga Dasar: Rp.
                            {{ $helper.formatThousand(row.item.base_price)
                            }}<br />
                            Kloter {{ $helper.parseDate(row.item.created)
                            }}<br />
                            {{ row.item.source || "-" }}
                        </div>
                    </template>
                    <template v-slot:cell(detail)="row">
                        Grade <strong>{{ row.item.grade }}</strong>
                        <div class="small">
                            <div
                                v-if="
                                    row.item.item_spec_id == 2 &&
                                        row.item.is_handphone == 0
                                "
                            >
                                Spek <strong>ORI</strong><br />
                            </div>
                            <div v-else>
                                Spek <strong>{{ row.item.spec }}</strong
                                ><br />
                            </div>
                            {{
                                row.item.is_batangan == true
                                    ? "Batangan"
                                    : "Lengkap"
                            }}<br />
                            {{
                                row.item.warehouse == null
                                    ? "-"
                                    : "Gudang " + row.item.warehouse
                            }}
                            - {{ row.item.office }}
                        </div>
                    </template>
                    <template v-slot:cell(status)="row">
                        <b-badge :variant="parseStatus(row.item.status, 0)">{{
                            parseStatus(row.item.status, 1)
                        }}</b-badge>
                    </template>
                    <template v-slot:cell(action)="row">
                        <b-button
                            size="sm"
                            variant="primary"
                            v-b-tooltip.hover.top
                            title="Detail"
                            @click="showDetail(row.item)"
                        >
                            <i class="fa fa-fw fa-info" />
                        </b-button>
                        <b-button
                            size="sm"
                            class="ml-2"
                            variant="dark"
                            v-b-tooltip.hover.top
                            title="Gambar Fisik"
                            :disabled="isSubmitting"
                            @click="prepareImage(row.item, 'fisik')"
                        >
                            <i class="fa fa-fw fa-camera" />
                        </b-button>
                        <b-button
                            size="sm"
                            class="ml-2"
                            variant="dark"
                            v-b-tooltip.hover.top
                            title="Gambar Kerusakan"
                            :disabled="isSubmitting"
                            @click="prepareImage(row.item, 'kerusakan')"
                        >
                            <i class="fa fa-fw fa-photo" />
                        </b-button>
                        <b-button
                            size="sm"
                            class="ml-2"
                            v-if="isFovidServiceCenterAllowed(row.item)"
                            variant="dark"
                            v-b-tooltip.hover.top
                            title="Fovid Service Center"
                            :disabled="isSubmitting"
                            @click="prepareFovidServiceCenter(row.item)"
                        >
                            <i class="fa fa-fw fa-arrow-circle-up" />
                        </b-button>
                        <b-button
                            size="sm"
                            v-if="isAdjustAllowed(row.item)"
                            class="ml-2"
                            variant="dark"
                            v-b-tooltip.hover.top
                            title="Adjustment Barang"
                            :disabled="isSubmitting"
                            @click="prepareAdjustment(row.item)"
                        >
                            <i class="fa fa-fw fa-wrench" />
                        </b-button>
                        <b-button
                            size="sm"
                            class="ml-2"
                            variant="dark"
                            v-b-tooltip.hover.top
                            title="Update Warna"
                            :disabled="isSubmitting"
                            @click="prepareColorUpdate(row.item)"
                        >
                            <i class="fa fa-fw fa-paint-brush" />
                        </b-button>
                        <b-button
                            size="sm"
                            v-if="isPrintAllowed(row.item)"
                            class="ml-2"
                            variant="dark"
                            v-b-tooltip.hover.top
                            title="Print Barcode"
                            @click="prepareReprint(row.item.id)"
                        >
                            <i class="fa fa-fw fa-print" />
                        </b-button>
                        <b-button
                            size="sm"
                            v-if="
                                isMoveInventoryAllowed &&
                                    isMoveAllowed(row.item)
                            "
                            class="ml-2"
                            variant="warning"
                            v-b-tooltip.hover.top
                            title="Pindah Gudang"
                            @click="prepareMove(row.item)"
                        >
                            <i class="fa fa-fw fa-truck" />
                        </b-button>
                        <b-button
                            size="sm"
                            v-if="
                                isRequestResetAllowed &&
                                    isResetAllowed(row.item)
                            "
                            class="ml-2"
                            variant="danger"
                            v-b-tooltip.hover.top
                            title="Reset ke Temuan"
                            @click="prepareReset(row.item)"
                        >
                            <i class="fa fa-fw fa-refresh" />
                        </b-button>
                        <b-button
                            size="sm"
                            v-if="
                                isRequestResetAllowed &&
                                    isResetAllowed(row.item)
                            "
                            class="ml-2"
                            variant="warning"
                            v-b-tooltip.hover.top
                            title="Reset Grade"
                            @click="prepareResetGrade(row.item)"
                        >
                            <i class="fa fa-fw fa-star-half-o" />
                        </b-button>
                    </template>
                    <template #table-busy>
                        <div class="d-flex justify-content-center">
                            <b-spinner label="Loading..." />
                        </div>
                    </template>
                </b-table>
                <PageSizer
                    :totalRows="totalRows"
                    :page="currentPage"
                    :options="options"
                    @limit-change="onLimitChange"
                    @page-change="onPageChange"
                />
            </template>
            <div class="d-flex justify-content-center mt-3">
                <b-spinner
                    v-if="isLoadingTable && !initTable"
                    label="Loading..."
                />
            </div>
        </b-card>

        <loading-overlay
            :fotoStartTime="uploadTimeStamp.startPresignedUrl"
            :fotoEndTime="uploadTimeStamp.endPresignedUrl"
            :uploadStartTime="uploadTimeStamp.startUploadToS3"
            :uploadEndTime="uploadTimeStamp.endUploadToS3"
            :penyimpananStartTime="uploadTimeStamp.startSaveFile"
            :penyimpananEndTime="uploadTimeStamp.endSaveFile"
            :show="isShowLoadingOverlay"
        />

        <b-modal
            id="m-detail"
            title="Detail Inventory"
            size="lg"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <DetailInventory :id="activeId" />
        </b-modal>

        <b-modal
            id="m-reprint-barcode"
            title="Reprint Barcode"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            hide-header-close
        >
            Silahkan cetak barcode dibawah ini. Mohon pastikan barcode tercetak
            dengan baik sebelum melanjutkan.
            <br /><br />
            <iframe :src="getBarcodeLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button
                            variant="dark"
                            :disabled="barcodeToggleCooldown"
                            @click="toggleBarcodeType"
                        >
                            Print
                            {{
                                barcodePage == "1"
                                    ? "Barcode tanpa harga"
                                    : "Barcode ada harga"
                            }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button
                            variant="primary"
                            @click="$bvModal.hide('m-reprint-barcode')"
                        >
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <b-modal
            id="m-move"
            title="Pindah Gudang"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            {{ activeItem.type }} - NF {{ activeItem.no_faktur_pgi
            }}<br /><br />
            <b-form-group label="Pindahkan ke...">
                <b-form-select
                    v-model="input.warehouse"
                    :options="optWarehouse"
                    text-field="name"
                    value-field="id"
                >
                    <template #first>
                        <b-form-select-option value="0" disabled
                            >Pilih Gudang...</b-form-select-option
                        >
                    </template>
                </b-form-select>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button
                    variant="primary"
                    :disabled="isSubmitting"
                    @click="promptMove"
                >
                    {{ isSubmitting ? "Memindahkan..." : "Pindahkan" }}
                </b-button>
            </div>
        </b-modal>
        <ModalDataPerubahan
            context="reset"
            :inventory-id="activeItem.id"
            :no-faktur="activeItem.no_faktur_pgi"
            :defaults="resetDefaults"
            @saved="getItems(currentPage)"
        />
        <ModalResetGrade
            :inventory-id="activeItem.id"
            :no-faktur="activeItem.no_faktur_pgi"
            :current-grade="activeItem.grade"
            @saved="getItems(currentPage)"
        />
        <b-modal
            id="m-barcode"
            title="Cetak Barcode"
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            hide-header-close
        >
            Silahkan cetak barcode dibawah ini. Mohon pastikan barcode tercetak
            dengan baik sebelum melanjutkan.
            <br /><br />
            <iframe :src="getBarcodeMoveLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button
                            variant="dark"
                            :disabled="barcodeToggleCooldown"
                            @click="toggleBarcodeMoveType"
                        >
                            Print
                            {{
                                barcodeMoveType == "barcode"
                                    ? "Kerusakan"
                                    : "Barcode"
                            }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button
                            variant="primary"
                            @click="$bvModal.hide('m-barcode')"
                        >
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        <b-modal
            id="m-filter"
            title="Filter Pencarian"
            size="lg"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <strong>DATA BARANG</strong>
            <b-row class="mt-1">
                <b-col md="4">
                    <b-form-group label="Nama Barang">
                        <b-form-input v-model="filter.name" maxlength="50" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Divisi">
                        <multiselect
                            v-model="filter.division"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optDivision"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Jenis">
                        <multiselect
                            v-model="filter.kind"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optKind"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4">
                    <b-form-group label="Merk">
                        <multiselect
                            v-model="filter.brand"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optBrand"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Tahun / Generasi Barang">
                        <b-form-input v-model="filter.itemYear" maxlength="4" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="No. Faktur PGI">
                        <b-form-input
                            v-model="filter.noFaktur"
                            maxlength="50"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4">
                    <b-form-group label="IMEI / SN">
                        <b-form-input v-model="filter.imeiSn" maxlength="100" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="No. Faktur Original">
                        <b-form-input
                            v-model="filter.noFakturOriginal"
                            maxlength="100"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <hr />
            <strong>PENILAIAN DAN STATUS BARANG</strong>
            <b-row class="mt-1">
                <b-col md="6">
                    <b-form-group label="Status">
                        <multiselect
                            :multiple="true"
                            :close-on-select="false"
                            v-model="filter.status"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optStatus"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Grade">
                        <multiselect
                            :multiple="true"
                            :close-on-select="false"
                            v-model="filter.grade"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optGrade"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4">
                    <b-form-group label="Kelengkapan">
                        <b-form-select
                            v-model="filter.isBatangan"
                            :options="optIsBatangan"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Gudang">
                        <multiselect
                            v-model="filter.warehouse"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optWarehouse"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Spek">
                        <multiselect
                            v-model="filter.spec"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optSpec"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <hr />
            <strong>KLOTER PENGIRIMAN</strong>
            <b-row class="mt-1">
                <b-col md="4">
                    <b-form-group label="Dari">
                        <b-form-input type="date" v-model="filter.from" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Sampai">
                        <b-form-input type="date" v-model="filter.to" />
                    </b-form-group>
                </b-col>
            </b-row>
            <strong>KERUSAKAN</strong>
            <b-row class="mt-1">
                <b-col md="4">
                    <b-form-group label="Kategori kerusakan">
                        <multiselect
                            v-model="filter.category"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optFilterCategory"
                        />
                        <small>*Pilih jenis terlebih dahulu</small>
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Keterangan">
                        <multiselect
                            :multiple="true"
                            :close-on-select="false"
                            v-model="filter.adjustment"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optFilterAdjustments"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <div class="mt-4 text-right">
                <b-button variant="danger" @click="resetFilter">
                    Reset Filter
                </b-button>
                <b-button variant="primary" class="ml-3" @click="getItems()">
                    Cari
                </b-button>
            </div>
        </b-modal>
        <b-modal
            id="m-download-report"
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            hide-header-close
            ref="downloadModal"
        >
            <template #modal-title>
                {{ modalTitleDownload }}
                <button
                    type="button"
                    class="close"
                    aria-label="Close"
                    :disabled="fetchReportStatus == 0"
                    @click="$refs.downloadModal.hide()"
                    style="position: absolute; top: 0.5rem; right: 1rem;"
                >
                    <b-spinner small v-if="fetchReportStatus == 0" />
                    <span v-else aria-hidden="true">&times;</span>
                </button>
            </template>
            <div v-if="fetchReportStatus == 0">
                Menyiapkan laporan, mohon menunggu...
            </div>
            <div v-else-if="fetchReportStatus == -1">
                Gagal mendapatkan laporan, mohon coba kembali!
            </div>
            <div v-else>
                Silahkan tekan tombol dibawah ini untuk download laporan.
                <div class="mt-2">
                    <a :href="reportPath" download>
                        <b-button variant="success">
                            <i class="fa fa-download mr-2" />Download
                        </b-button>
                    </a>
                </div>
            </div>
        </b-modal>
        <b-modal
            id="m-image-old"
            :title="'Edit Gambar Fisik Item ' + activeItem.type"
            size="xl"
            @close="onCloseModalImage"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <!-- Menyiapkan request reset {{ resetType.toLowerCase() }} untuk NF {{ activeItem.no_faktur_pgi }}<br /><br />
            <b-form-group label="Keterangan">
                <b-input v-model="resetReason" maxlength="200" />
            </b-form-group> -->
            <b-row>
                <b-col cols="12" lg="8">
                    <div class="media-container">
                        <b-img-lazy
                            v-if="mediaPreview.media == 'image'"
                            class="media-preview"
                            :src="
                                mediaPreview.status == 'upload'
                                    ? mediaPreview.url
                                    : mediaPreview.computedImageUrl
                            "
                            blank-src="image-loading.gif"
                            block
                            alt="Image Preview"
                        ></b-img-lazy>
                        <video
                            v-else-if="mediaPreview.media == 'video'"
                            class="media-preview"
                            controls
                            :key="mediaPreview.url"
                        >
                            <source
                                v-if="mediaPreview.type == 'video/webm'"
                                :src="
                                    mediaPreview.status == 'upload'
                                        ? mediaPreview.url
                                        : mediaPreview.url
                                "
                                :type="mediaPreview.type"
                            />
                            <source
                                v-else-if="mediaPreview.type == 'video/ogg'"
                                :src="
                                    mediaPreview.status == 'upload'
                                        ? mediaPreview.url
                                        : mediaPreview.url
                                "
                                :type="mediaPreview.type"
                            />
                            <source
                                v-else-if="mediaPreview.type == 'video/mp4'"
                                :src="
                                    mediaPreview.status == 'upload'
                                        ? mediaPreview.url
                                        : mediaPreview.url
                                "
                                :type="mediaPreview.type"
                            />
                            <source
                                v-else-if="mediaPreview.type == 'video/3gpp'"
                                :src="
                                    mediaPreview.status == 'upload'
                                        ? mediaPreview.url
                                        : mediaPreview.url
                                "
                                :type="mediaPreview.type"
                            />
                            <!-- <source v-else :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url" :type="mediaPreview.type"> -->
                            Your browser does not support the video tag.
                        </video>
                        <b-img-lazy
                            v-else
                            class="media-preview"
                            src="/img/img-preview.png"
                            block
                            alt="No Image"
                        ></b-img-lazy>
                    </div>
                    <div
                        v-if="mediaPreview.title"
                        class="d-flex justify-content-center my-3"
                    >
                        <h4>{{ mediaPreview.title || "-" }}</h4>
                    </div>
                    <div class="media-scroll">
                        <div
                            class="media-scroll-content"
                            v-for="(media, index) in filterMediaList"
                            :key="'ms-' + index"
                            @click="onClickImage(media.url)"
                        >
                            <b-img-lazy
                                class="media-scroll-preview"
                                :class="{ active: media.isActive }"
                                :src="
                                    media.computedImageUrl ||
                                        '/img/img-loading.gif'
                                "
                                blank-src="/img/image-loading.gif"
                                block
                                :alt="media.altText"
                            ></b-img-lazy>
                            <!-- <b-img-lazy class="media-scroll-preview" :class="{ active: media.isActive }" src="https://sample-videos.com/img/Sample-png-image-5mb.png" blank-src="/img/image-loading.gif" block :alt="media.altText"></b-img-lazy> -->
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" lg="4" class="border-responsive">
                    <!-- <b-button block variant="success"
                        :disabled="filterMediaList.length >= 10 || isSubmitting || prepareImageType == 'kerusakan' || activeItem.is_public"
                        @click="onAddImage">

                        {{ isSubmitting ? "Menyimpan..." : "Upload Item Gambar Baru" }}
                    </b-button> -->
                    <b-button
                        block
                        variant="primary"
                        :disabled="
                            typeof mediaPreview.url === 'undefined' ||
                                isSubmitting
                        "
                        @click="onOpenImage(mediaPreview.url)"
                    >
                        {{
                            isSubmitting
                                ? "Menyimpan..."
                                : "Tampilkan Item di Tab Baru"
                        }}
                    </b-button>
                    <!-- <b-button block variant="danger"
                        :disabled="typeof (mediaPreview.url) === 'undefined' || isSubmitting || prepareImageType == 'kerusakan' || activeItem.is_public"
                        @click="onDeleteImage(mediaPreview.url)">

                        {{ isSubmitting ? "Menyimpan..." : "Hapus Item" }}
                    </b-button> -->
                    <div
                        class="mt-3 media-disclaimer"
                        v-if="prepareImageType == 'kerusakan'"
                    >
                        <small
                            >*Menu ini sudah tidak dapat digunakan untuk upload
                            / delete gambar. Mohon menggunakan menu gambar pada
                            adjustment barang.</small
                        ><br />
                        <!-- <small>*Jenis item gambar yang dapat diterima oleh sistem adalah format JPG, JPEG, dan PNG.</small><br> -->
                        <!-- <small>*Jenis item video yang dapat diterima oleh sistem adalah format MP4, OGG, dan WEBM.</small><br> -->
                        <!-- <small>*Maksimal ukuran gambar / video yang dapat diterima oleh sistem sebesar 1MB.</small><br> -->
                        <!-- <small>*Minimal jumlah item gambar / video per inventori sebanyak 3 buah item.</small><br> -->
                        <!-- <small>*Maksimal jumlah item gambar / video per inventori sebanyak 8 buah item.</small> -->
                    </div>
                    <div class="mt-3 media-disclaimer" v-else>
                        <small
                            >*Jenis item gambar yang dapat diterima oleh sistem
                            adalah format JPG, JPEG, dan PNG.</small
                        ><br />
                        <small
                            >*Maksimal ukuran total gambar untuk sekali upload
                            sebesar 400MB.</small
                        ><br />
                        <small
                            >*Minimal jumlah item gambar per inventori sebanyak
                            1 buah item.</small
                        ><br />
                        <small
                            >*Maksimal jumlah item gambar per inventori sebanyak
                            10 buah item.</small
                        >
                    </div>
                </b-col>
            </b-row>
            <div class="mt-4 text-right">
                <b-button
                    variant="secondary"
                    class="mr-2"
                    :disabled="isSubmitting"
                    @click="$bvModal.hide('m-image-old')"
                >
                    Batal
                </b-button>
                <!-- <b-button variant="primary" :disabled="isSubmitting || activeItem.is_public"
                    @click="onSaveImageFisik(activeItem.id)">

                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button> -->
            </div>
            <input
                multiple
                style="opacity: 0; filter:alpha(opacity=0);"
                ref="fileupload"
                type="file"
                @change="onUploadImage"
                accept="image/png, image/jpeg"
            />
        </b-modal>
        <b-modal
            id="m-image"
            :title="
                'Edit Gambar Kerusakan Item ' +
                    activeItem.type +
                    ' (' +
                    activeAdjustmentRow.name +
                    ')'
            "
            size="xl"
            @close="onCloseModalImage"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <b-row>
                <b-col cols="12" lg="8">
                    <div class="media-container">
                        <b-img-lazy
                            v-if="mediaPreview.media == 'image'"
                            class="media-preview"
                            :src="
                                mediaPreview.status == 'upload'
                                    ? mediaPreview.url
                                    : mediaPreview.computedImageUrl
                            "
                            blank-src="image-loading.gif"
                            block
                            alt="Image Preview"
                        ></b-img-lazy>
                        <video
                            v-else-if="mediaPreview.media == 'video'"
                            class="media-preview"
                            controls
                            :key="mediaPreview.url"
                        >
                            <source
                                v-if="mediaPreview.type == 'video/webm'"
                                :src="
                                    mediaPreview.status == 'upload'
                                        ? mediaPreview.url
                                        : mediaPreview.url
                                "
                                :type="mediaPreview.type"
                            />
                            <source
                                v-else-if="mediaPreview.type == 'video/ogg'"
                                :src="
                                    mediaPreview.status == 'upload'
                                        ? mediaPreview.url
                                        : mediaPreview.url
                                "
                                :type="mediaPreview.type"
                            />
                            <source
                                v-else-if="mediaPreview.type == 'video/mp4'"
                                :src="
                                    mediaPreview.status == 'upload'
                                        ? mediaPreview.url
                                        : mediaPreview.url
                                "
                                :type="mediaPreview.type"
                            />
                            <source
                                v-else-if="mediaPreview.type == 'video/3gpp'"
                                :src="
                                    mediaPreview.status == 'upload'
                                        ? mediaPreview.url
                                        : mediaPreview.url
                                "
                                :type="mediaPreview.type"
                            />
                            <!-- <source v-else :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url" :type="mediaPreview.type"> -->
                            Your browser does not support the video tag.
                        </video>
                        <b-img-lazy
                            v-else
                            class="media-preview"
                            src="/img/img-preview.png"
                            block
                            alt="No Image"
                        ></b-img-lazy>
                    </div>
                    <div class="media-scroll">
                        <div
                            class="media-scroll-content"
                            v-for="(media, index) in filterMediaList"
                            :key="'ms-' + index"
                            @click="onClickImage(media.url)"
                        >
                            <b-img-lazy
                                class="media-scroll-preview"
                                :class="{ active: media.isActive }"
                                :src="
                                    media.media == 'video'
                                        ? '/img/video-thumbnail.png'
                                        : media.status == 'upload'
                                        ? media.url
                                        : media.url
                                "
                                blank-src="/img/image-loading.gif"
                                block
                                :alt="media.altText"
                            ></b-img-lazy>
                            <!-- <b-img-lazy class="media-scroll-preview" :class="{ active: media.isActive }" src="https://sample-videos.com/img/Sample-png-image-5mb.png" blank-src="/img/image-loading.gif" block :alt="media.altText"></b-img-lazy> -->
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" lg="4" class="border-responsive">
                    <!-- <b-button block variant="success" :disabled="filterMediaList.length >= 10 || isSubmitting"
                        @click="onAddImage">
                        {{ isSubmitting ? "Menyimpan..." : "Upload Item Gambar / Video Baru" }}
                    </b-button> -->

                    <b-button
                        block
                        variant="warning"
                        class="mb-2"
                        @click="onRefreshImage()"
                    >
                        Refresh
                    </b-button>

                    <span v-show="!isUpload" id="uploadFile" class="my-2">
                        <b-button
                            block
                            variant="success"
                            @click="triggerFileInputForAdjustment"
                            :disabled="!hasAddPhotoAdjPermission"
                        >
                            {{
                                isSubmitting
                                    ? "Menyimpan..."
                                    : "Upload Item Gambar / Video Baru"
                            }}
                        </b-button>
                        <input
                            type="file"
                            ref="fileInputAdjustment"
                            style="display: none;"
                            accept="image/jpeg, image/png, video/mp4, video/quicktime"
                            @change="uploadFileForAdjustment"
                            multiple
                        />
                    </span>

                    <b-button
                        block
                        variant="primary"
                        class="mt-2"
                        :disabled="
                            typeof mediaPreview.url === 'undefined' ||
                                isSubmitting
                        "
                        @click="onOpenImage(mediaPreview.url)"
                    >
                        {{
                            isSubmitting
                                ? "Menyimpan..."
                                : "Tampilkan Item di Tab Baru"
                        }}
                    </b-button>
                    <b-button
                        block
                        variant="danger"
                        :disabled="
                            typeof mediaPreview.url === 'undefined' ||
                                isSubmitting ||
                                !hasDeletePhotoAdjPermission
                        "
                        @click="onDeleteImage(mediaPreview.url)"
                    >
                        {{ isSubmitting ? "Menyimpan..." : "Hapus Item" }}
                    </b-button>
                    <div class="mt-3 media-disclaimer">
                        <small
                            >*Jenis item gambar yang dapat diterima oleh sistem
                            adalah format JPG, JPEG, dan PNG.</small
                        ><br />
                        <small
                            >*Jenis item video yang dapat diterima oleh sistem
                            adalah format MP4, OGG, dan WEBM.</small
                        ><br />
                        <small
                            >*Maksimal ukuran total gambar / video untuk sekali
                            upload sebesar 400MB.</small
                        ><br />
                        <small
                            >*Minimal jumlah item gambar / video per inventori
                            sebanyak 1 buah item.</small
                        ><br />
                        <small
                            >*Maksimal jumlah item gambar / video per inventori
                            sebanyak 10 buah item.</small
                        >
                    </div>
                </b-col>
            </b-row>
            <input
                multiple
                style="opacity: 0; filter:alpha(opacity=0);"
                ref="fileupload"
                type="file"
                @change="onUploadImage"
                accept="image/png, image/jpeg, video/mp4, video/webm, video/ogg"
            />
        </b-modal>

        <b-modal
            id="m-fovid-service-center-image"
            :title="'Edit Gambar Fovid Service Center Item ' + activeItem.type"
            size="xl"
            @close="onCloseModalImage"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <b-row>
                <b-col cols="12" lg="8">
                    <div class="media-container">
                        <b-img-lazy
                            v-if="mediaPreview.media == 'image'"
                            class="media-preview"
                            :src="
                                mediaPreview.status == 'upload'
                                    ? mediaPreview.url
                                    : mediaPreview.computedImageUrl
                            "
                            blank-src="image-loading.gif"
                            block
                            alt="Image Preview"
                        ></b-img-lazy>
                        <video
                            v-else-if="mediaPreview.media == 'video'"
                            class="media-preview"
                            controls
                            :key="mediaPreview.url"
                        >
                            <source
                                :src="
                                    mediaPreview.status == 'upload'
                                        ? mediaPreview.url
                                        : mediaPreview.url
                                "
                                :type="mediaPreview.type"
                            />
                            Your browser does not support the video tag.
                        </video>
                        <b-img-lazy
                            v-else
                            class="media-preview"
                            src="/img/img-preview.png"
                            block
                            alt="No Image"
                        ></b-img-lazy>
                    </div>
                    <div class="media-scroll">
                        <div
                            class="media-scroll-content"
                            v-for="(media, index) in filterMediaList"
                            :key="'ms-' + index"
                            @click="onClickImage(media.url)"
                        >
                            <b-img-lazy
                                class="media-scroll-preview"
                                :class="{ active: media.isActive }"
                                :src="
                                    media.media == 'video'
                                        ? '/img/video-thumbnail.png'
                                        : media.status == 'upload'
                                        ? media.url
                                        : media.url
                                "
                                blank-src="/img/image-loading.gif"
                                block
                                :alt="media.altText"
                            ></b-img-lazy>
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" lg="4" class="border-responsive">
                    <b-button
                        block
                        variant="warning"
                        class="mb-2"
                        @click="onRefreshImageFovidServiceCenter()"
                    >
                        Refresh
                    </b-button>

                    <b-button
                        block
                        variant="success"
                        @click="triggerFileInputForFovidServiceCenter"
                    >
                        {{
                            isSubmitting
                                ? "Menyimpan..."
                                : "Upload Item Gambar / Video Baru"
                        }}
                    </b-button>
                    <input
                        type="file"
                        ref="fileInputFovidServiceCenter"
                        style="display: none;"
                        accept="image/jpeg, image/png, video/mp4, video/quicktime"
                        @change="uploadFileForFovidServiceCenter"
                        multiple
                    />

                    <b-button
                        block
                        variant="primary"
                        class="mt-2"
                        :disabled="
                            typeof mediaPreview.url === 'undefined' ||
                                isSubmitting
                        "
                        @click="onOpenImage(mediaPreview.url)"
                    >
                        {{
                            isSubmitting
                                ? "Menyimpan..."
                                : "Tampilkan Item di Tab Baru"
                        }}
                    </b-button>
                    <b-button
                        block
                        variant="danger"
                        :disabled="
                            typeof mediaPreview.url === 'undefined' ||
                                isSubmitting
                        "
                        @click="
                            onDeleteImageFovidServiceCenter(mediaPreview.url)
                        "
                    >
                        {{ isSubmitting ? "Menyimpan..." : "Hapus Item" }}
                    </b-button>
                    <div class="mt-3 media-disclaimer">
                        <small
                            >*Jenis item gambar yang dapat diterima oleh sistem
                            adalah format JPG, JPEG, dan PNG.</small
                        ><br />
                        <small
                            >*Jenis item video yang dapat diterima oleh sistem
                            adalah format MP4, OGG, dan WEBM.</small
                        ><br />
                        <small
                            >*Maksimal ukuran total gambar / video untuk sekali
                            upload sebesar 400MB.</small
                        >
                    </div>
                </b-col>
            </b-row>

            <input
                multiple
                style="opacity: 0; filter:alpha(opacity=0);"
                ref="fileupload"
                type="file"
                @change="uploadFileForFovidServiceCenter"
                accept="image/png, image/jpeg, video/mp4, video/webm, video/ogg"
            />
        </b-modal>

        <b-modal
            id="m-item-to-adjust"
            title="Adjustment Barang Masuk"
            size="xl"
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <div>
                <b-table
                    bordered
                    hover
                    show-empty
                    no-local-sorting
                    :items="invoiceAdjustments"
                    :fields="fieldsAdjust"
                    responsive
                    class="my-4"
                >
                    <template v-slot:empty>
                        Tidak ada adjustment.
                    </template>
                    <template v-slot:cell(category)="row">
                        <div>
                            {{ row.item.category_name }}
                        </div>
                    </template>
                    <template v-slot:cell(name)="row">
                        <div>
                            {{ row.item.name }}
                        </div>
                    </template>
                    <template v-slot:cell(adjustment)="row">
                        <b-input-group
                            :prepend="checkAdjustment(row.item).prepend"
                        >
                            <b-form-input
                                :value="
                                    String(row.item.adjustment).replace('-', '')
                                "
                                :class="checkAdjustment(row.item).class"
                                @input="sanitize(row.item)"
                                disabled
                            ></b-form-input>
                        </b-input-group>
                    </template>
                    <template v-slot:cell(adjustmentPercent)="row">
                        <b-input-group append="%">
                            <b-form-input
                                v-model="row.item.adjustmentPercentage"
                                @input="changeAdjustment"
                                disabled
                            ></b-form-input>
                        </b-input-group>
                    </template>
                    <template v-slot:cell(action)="row">
                        <div class="d-flex">
                            <b-button
                                size="sm"
                                variant="dark"
                                v-b-tooltip.hover.top
                                title="Gambar Kerusakan"
                                :disabled="isSubmitting"
                                @click="prepareAdjImage(row.item)"
                            >
                                <i class="fa fa-fw fa-picture-o" />
                            </b-button>
                            <b-button
                                size="sm"
                                class="ml-2"
                                variant="dark"
                                v-b-tooltip.hover.top
                                title="Edit Harga"
                                :disabled="
                                    activeItem.status == '3' ||
                                        isSubmitting ||
                                        !hasEditAdjPricePermission
                                "
                                @click="editAdjustment(row.item)"
                            >
                                <i class="fa fa-fw fa-pencil" />
                            </b-button>
                            <b-button
                                v-if="hasEditAdjAfterSoldPermission"
                                size="sm"
                                class="ml-2"
                                variant="dark"
                                v-b-tooltip.hover.top
                                title="Edit Item Adjustment"
                                :disabled="isSubmitting"
                                @click="editItemAdjustment(row.item)"
                            >
                                <i class="fa fa-fw fa-edit" />
                            </b-button>
                            <b-button
                                variant="danger"
                                size="sm"
                                class="ml-2"
                                v-b-tooltip.hover.top
                                title="Hapus"
                                :disabled="
                                    activeItem.status == '3' ||
                                        activeItem.is_public ||
                                        !hasDeleteAdjInventoryPermission
                                "
                                @click="deleteRow(row.item)"
                            >
                                <i class="fa fa-fw fa-times" />
                            </b-button>
                        </div>
                    </template>
                </b-table>
                <b-row v-if="hasAddAdjInventoryPermission">
                    <b-col md="8" class="d-flex">
                        <b-button
                            class="mr-2"
                            variant="dark"
                            @click="prepareAddAdjustment"
                            :disabled="
                                (activeItem.status == '3' &&
                                    !activeItem.fixing_adjustment) ||
                                    isSubmitting ||
                                    activeItem.is_public
                            "
                        >
                            <i class="fa fa-plus mr-2" />Tambah Keterangan
                        </b-button>
                        <!-- <b-button v-if="isShowSimulationAdjDamage" variant="dark" @click="calculatedAdjustment"
                            :disabled="isSubmitCalculate || this.invoiceAdjustments.length == 0">
                            <i class="fa fa-calculator mr-2"/>
                            Simulasi Adjustment Kerusakan
                        </b-button> -->
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <b-modal
            id="m-add-adjustment"
            title="Tambah Adjustment"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <b-form-group label="Jenis Barang">
                <b-form-select
                    v-model="addAdj.kind"
                    :options="addAdj.optKind"
                    disabled
                />
            </b-form-group>
            <b-form-group label="Kategori Kerusakan">
                <b-form-select
                    v-model="addAdj.category"
                    :options="optCategory"
                    @input="onChangeAdjCategory"
                />
            </b-form-group>
            <b-form-group label="Keterangan">
                <b-form-select
                    v-model="addAdj.name"
                    :options="addAdj.optAdjustments"
                    :disabled="
                        $helper.isBlank(addAdj.category) ||
                            addAdj.optAdjustments.length <= 0
                    "
                    @change="onSelectAdjustment"
                />
            </b-form-group>
            <b-form-group label="Adjustment Harga (Nominal)">
                <b-input-group
                    :prepend="`Rp. ${addAdj.is_increment == 0 ? '-' : ''}`"
                >
                    <b-form-input
                        v-model="addAdj.adjustment"
                        @input="sanitize(addAdj)"
                        :class="{
                            'text-danger': addAdj.is_increment == 0,
                            'text-success': addAdj.is_increment == 1
                        }"
                        :disabled="
                            $helper.isBlank(addAdj.name) ||
                                activeItem.fixing_adjustment == 1 ||
                                addAdj.hasAdjustmentPrice
                        "
                        maxlength="50"
                    />
                </b-input-group>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button
                    variant="primary"
                    :disabled="isSubmitting"
                    @click="confirmAddAdjustment"
                >
                    {{ isSubmitting ? "Menambah..." : "Tambah" }}
                </b-button>
            </div>
        </b-modal>

        <b-modal
            id="m-update-color"
            title="Update Warna Barang"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <b-form-group label="Warna Barang">
                <multiselect
                    v-model="inputColor"
                    label="name"
                    track-by="id"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    :options="optColor"
                    placeholder="Pilih Warna"
                />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button
                    variant="primary"
                    :disabled="isSubmitting || activeItem.is_public"
                    @click="confirmUpdateColor"
                >
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>

        <b-modal
            id="m-edit-adjustment"
            title="Edit Harga Adjustment"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <b-form-group label="Adjustment Harga (Nominal)">
                <b-input-group
                    :prepend="`Rp. ${editAdj.is_increment == 0 ? '-' : ''}`"
                >
                    <b-form-input
                        v-model="editAdj.adjustment"
                        @input="sanitize(editAdj)"
                        :class="{
                            'text-danger': editAdj.is_increment == 0,
                            'text-success': editAdj.is_increment == 1
                        }"
                        maxlength="50"
                    />
                </b-input-group>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button
                    variant="primary"
                    :disabled="isSubmitting"
                    @click="confirmEditAdjustment"
                >
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>

        <b-modal
            id="m-sync-adjustment-confirm"
            title="Konfirmasi Update Harga Adjustment"
            centered
            hide-footer
        >
            <div>
                Apakah Anda yakin ingin mengupdate harga adjustment dengan data
                rumus?
            </div>
            <div class="mt-4 text-right">
                <b-button
                    variant="secondary"
                    @click="$bvModal.hide('m-sync-adjustment-confirm')"
                    :disabled="isSubmitting"
                >
                    Batal
                </b-button>
                <b-button
                    variant="primary"
                    class="ml-2"
                    @click="syncAdjustmentPrice"
                    :disabled="isSubmitting"
                >
                    {{ isSubmitting ? "Memproses..." : "Ya, Update" }}
                </b-button>
            </div>
        </b-modal>

        <b-modal
            id="m-edit-item-adjustments"
            title="Edit Adjustment"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <b-row class="mb-3" v-if="editItemAdj">
                <b-col>
                    <div>
                        <strong>Kategori:</strong>
                        {{ editItemAdj.category_name || "-" }}
                    </div>
                    <div>
                        <strong>Keterangan:</strong>
                        {{ editItemAdj.name || "-" }}
                    </div>
                </b-col>
            </b-row>
            <b-form-group label="Kategori Kerusakan">
                <b-form-select
                    v-model="editItemAdj.new_category"
                    :options="optCategory"
                    @input="onChangeNewAdjCategory"
                />
            </b-form-group>
            <b-form-group label="Keterangan">
                <b-form-select
                    v-model="editItemAdj.new_adjustment_id"
                    :options="editItemAdj.new_optAdjustments"
                    :disabled="
                        $helper.isBlank(editItemAdj.new_category) ||
                            editItemAdj.new_optAdjustments.length <= 0
                    "
                    @change="onSelectNewAdjustment"
                />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button
                    variant="primary"
                    :disabled="isSubmitting"
                    @click="confirmEditItemAdjustment"
                >
                    {{ isSubmitting ? "Menyimpan..." : "Perbarui" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import DetailInventory from "./DetailInventory.vue";
import lodash from "lodash";
import Uploading from "./Uploading.vue";
import LoadingOverlay from "./LoadingOverlay.vue";
import EnumPermissions from "@/shared/enum-permissions";
import ModalDataPerubahan from "../temuan-inventory/ModalDataPerubahan.vue";
import ModalResetGrade from "./ModalResetGrade.vue";

export default {
    components: {
        DetailInventory,
        Uploading,
        LoadingOverlay,
        ModalDataPerubahan,
        ModalResetGrade
    },
    data() {
        return {
            initStatus: 0,
            initTable: 0,
            isLoadingTable: false,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            isDownloadExcelAllowed: false,
            isMoveInventoryAllowed: false,
            isRequestResetAllowed: false,

            fetchReportStatus: 0,
            reportPath: "",

            activeId: 0,
            resetDefaults: null,

            filter: {
                name: "",
                division: null,
                kind: null,
                brand: null,
                itemYear: "",
                spec: null,
                warehouse: null,
                noFaktur: "",
                imeiSn: "",
                grade: [],
                isBatangan: -1,
                status: [],
                from: null,
                to: null,
                category: null,
                adjustment: [],
                noFakturOriginal: null
            },

            input: {
                warehouse: 0
            },

            inputColor: {},

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],

            fields: [
                { key: "item", label: "Barang", sortable: true },
                { key: "price", label: "Harga Jual", sortable: true },
                { key: "detail", label: "Detail", sortable: true },
                { key: "status", label: "Status", sortable: true },
                { key: "action", label: "Aksi" }
            ],

            fieldsAdjust: [
                {
                    key: "category",
                    label: "Kategori",
                    sortable: false,
                    thClass: "adjust-column-min"
                },
                {
                    key: "name",
                    label: "Keterangan",
                    sortable: false,
                    thClass: "adjust-column-min"
                },
                {
                    key: "adjustment",
                    label: "Potongan / Tambahan Harga (Nominal)",
                    sortable: false
                },
                { key: "action", label: "Aksi" }
            ],

            items: [],
            activeItem: {},
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optKind: [],
            optDivision: [{ id: 1, name: "HP" }, { id: 2, name: "NON HP" }],
            optBrand: [],
            optSpec: [],
            optWarehouse: [],
            optColor: [],

            optGrade: [
                { id: "S", name: "S" },
                { id: "A", name: "A" },
                { id: "B", name: "B" },
                { id: "C", name: "C" },
                { id: "D", name: "D" },
                { id: "E", name: "E" },
                { id: "X", name: "X" }
            ],
            optIsBatangan: [
                { value: -1, text: "Semua" },
                { value: 1, text: "Batangan" },
                { value: 0, text: "Lengkap" }
            ],
            optStatus: [
                // { value: -1, text: "Semua" },
                { id: 2, name: "READY" },
                { id: 7, name: "DRAFT" },
                { id: 3, name: "TERJUAL" },
                { id: 4, name: "RETUR" },
                { id: 14, name: "DALAM PERJALANAN"},
                { id: 5, name: "HILANG" },
                { id: 55, name: "REQUEST HILANG" },
                { id: 6, name: "KIRIM BALIK PGI" },
                { id: 66, name: "REQUEST KIRIM BALIK" },
                { id: 8, name: "REQUEST RESET" },
                { id: 9, name: "REQUEST MOVE" },
                { id: 10, name: "INVENTARIS" },
                { id: 11, name: "REQUEST INVENTARIS" }
            ],

            mediaPreview: {},

            mediaList: [],

            isImageChanged: false,

            invoiceAdjustments: [],

            optAdjustments: [],

            optCategory: [],

            optFilterCategory: [],

            optFilterAdjustments: [],

            addAdj: {
                kind: null,
                optKind: [],
                category: null,
                name: null,
                optAdjustments: [],
                adjustment: "",
                adjustmentPercentage: "",
                hasAdjustmentPrice: false,
                selectedCategoryAdjustments: [],
                is_increment: null
            },
            editAdj: {
                adjustmentId: null,
                adjustment: "",
                pendingSyncAdjustmentId: null,
                is_increment: null
            },

            activeAdjustment: {},

            isChangeAdjustment: false,
            isChangePhotoAdjustment: false,

            prepareImageType: "",

            barcodeLink: "",
            barcodeLinkDamage: "",
            barcodeMoveLink: "",
            barcodeMoveLinkDamage: "",

            barcodePage: "1",
            barcodeMoveType: "barcode",
            barcodeToggleCooldown: false,

            uploadKey: 0,
            isUpload: false,

            activeAdjustmentRow: "",
            finalizeBroken: false,
            isShowLoadingOverlay: false,
            uploadTimeStamp: {
                startPresignedUrl: null,
                endPresignedUrl: null,
                startUploadToS3: null,
                endUploadToS3: null,
                startSaveFile: null,
                endSaveFile: null
            },
            modalTitleDownload: "",
            adjustmentPercentages: [],
            totalAdjustmentPrice: 0,
            fieldAdjustmentPercentages: [
                {
                    key: "adjustment_descrtiption",
                    label: "Kategori & Keterangan",
                    sortable: false,
                    thClass: "adjust-column-min"
                },
                {
                    key: "adjustment_price",
                    label: "Potongan / Tambahan Harga",
                    sortable: false
                }
            ],
            isSubmitCalculate: false,

            editItemAdj: {
                new_category: null,
                new_name: null,
                new_adjustment: null,
                new_adjustment_id: null,
                selectedCategoryAdjustments: []
            }
        };
    },

    watch: {
        "filter.kind": function(newVal) {
            this.filter.brand = null;
            this.optBrand = [];
            this.filter.category = null;
            this.optCategory = [];

            if (newVal != null) {
                this.$axios
                    .get("master/brands/" + this.filter.kind.id)
                    .then(res => {
                        this.optBrand = res.data.data;
                    });

                this.$axios
                    .get(
                        "category/selection?item_kind_id=" + this.filter.kind.id
                    )
                    .then(res => {
                        this.optFilterCategory = res.data.data;
                    });
            }
        },
        filterMediaList: {
            handler(newVal) {
                newVal.forEach(media => {
                    if (!media.computedImageUrl) {
                        this.setImageSource(media);
                    }
                });
            },
            deep: true,
            immediate: true
        },
        "filter.category": function(newVal) {
            this.filter.adjustment = [];
            this.optFilterAdjustments = [];

            if (newVal != null) {
                let params = {
                    item_kind_id: this.filter.kind.id,
                    category_id: this.filter.category.id
                };

                this.$axios
                    .get("adjustment/selection-category", { params })
                    .then(res => {
                        this.optFilterAdjustments = res.data.data;
                    });
            }
        },
        "filter.division": function(newVal) {
            this.filter.kind = null;
            this.optKind = [];
            this.filter.brand = null;
            this.optBrand = [];
            this.filter.category = null;
            this.optCategory = [];

            if (newVal != null) {
                const params = {
                    division: this.filter.division.id
                };

                this.$axios.get("master/kinds", { params }).then(res => {
                    this.optKind = res.data.data;
                });
            }
        }
    },
    methods: {
        init() {
            this.initStatus = 0;
            // let getItems = this.getItems()

            let getWarehouses = this.$axios
                .get("master/warehouse/selection")
                .then(res => {
                    this.optWarehouse = res.data.data.map(it => {
                        return {
                            id: it.id,
                            name: it.name + " - " + it.office_name
                        };
                    });
                });

            let getSpecs = this.$axios
                .get("master/spec/selection")
                .then(res => {
                    this.optSpec = res.data.data;
                });

            let getColors = this.$axios
                .get("master/color/selection")
                .then(res => {
                    this.optColor = res.data.data;
                });

            let getDivision = this.$axios
                .get("division/get-all-filtered")
                .then(res => {
                    this.optDivision = this.optDivision.filter(division => {
                        return res.data.data.some(
                            item => item.id === division.id
                        );
                    });
                });

            Promise.all([getWarehouses, getSpecs, getColors, getDivision])
                .then(res => {
                    this.initStatus = 1;
                })
                .catch(error => (this.initStatus = -1));
        },

        checkAdjustment(item) {
            let val = Number(String(item.adjustment).replace(/\./g, ""));
            let result = {
                class: "",
                prepend: "Rp. "
            };

            if (val == 0) {
                result.class = "text-black";
            } else if (val < 0) {
                result.class = "text-danger";
                result.prepend = "Rp. -";
            } else if (val > 0) {
                result.class = "text-success";
            }
            return result;
        },

        showDetail(item) {
            this.activeItem = item;
            this.activeId = item.id;
            this.$bvModal.show("m-detail");
        },

        async changeFilter() {
            this.isLoadingTable = true;

            await this.getItems();

            // this.filter.noFaktur = ""
            // this.filter.imeiSn = ""

            this.isLoadingTable = false;
        },

        getItems(page = 1) {
            this.$bvModal.hide("m-filter");
            this.isBusy = true;
            this.items = [];
            this.initTable = 1;

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage
            );
            param += this.processFilter();

            if (!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy;
                param += "&sortDesc=" + this.sortDesc;
            }

            return this.$axios
                .get("inventory" + param)
                .then(res => {
                    this.items = res.data.data.items;
                    this.totalRows = res.data.data.total;
                    sessionStorage.setItem(
                        "listInventoryFilter",
                        JSON.stringify(this.filter)
                    );
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        getBarcodeLink() {
            return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLink}?page=${
                this.barcodePage
            }`;
        },

        toggleBarcodeType() {
            this.barcodeToggleCooldown = true;
            if (this.barcodePage == "1") this.barcodePage = "2";
            else this.barcodePage = "1";

            setTimeout(
                function() {
                    this.barcodeToggleCooldown = false;
                }.bind(this),
                2000
            );
        },

        getReprintBarcode() {
            this.isSubmitting = true;
            let payload = {
                id: this.activeId
            };

            this.$axios
                .post("inventory/reprint-barcode", payload)
                .then(res => {
                    this.barcodeLink = res.data.data.link;
                    this.barcodeLinkDamage = res.data.data.linkDamage;
                    this.$bvModal.show("m-reprint-barcode");
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        isPrintAllowed(item) {
            return [2, 4, 7].includes(item.status) && !item.is_public; // Hanya READY / RETUR / DRAFT dan bukan item public (ecom)
        },

        prepareReprint(id) {
            this.activeId = id;
            this.getReprintBarcode();
        },

        downloadExcelStock() {
            this.fetchReportStatus = 0;
            this.modalTitleDownload = "Download Excel Stock";
            this.$bvModal.show("m-download-report");

            let param = this.processFilter();

            this.$axios
                .get("inventory/excel-stock?" + param)
                .then(res => {
                    this.reportPath = res.data.data.path;
                    this.fetchReportStatus = 1;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                    this.fetchReportStatus = -1;
                })
                .finally(() => (this.isSubmitting = false));
        },

        downloadExcelDraft() {
            this.fetchReportStatus = 0;
            this.modalTitleDownload = "Download Excel Draft";
            this.$bvModal.show("m-download-report");
            this.$axios
                .post("report/stock-draft")
                .then(res => {
                    this.reportPath = res.data.data.path;
                    this.fetchReportStatus = 1;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                    this.fetchReportStatus = -1;
                })
                .finally(() => (this.isSubmitting = false));
        },

        downloadMarketplace() {
            this.fetchReportStatus = 0;
            this.modalTitleDownload = "Download Excel Marketplace";
            this.$bvModal.show("m-download-report");

            let url = "inventory/excel-marketplace?";

            if (!this.$helper.isBlank(this.filter.division)) {
                url += "filterDivision=" + this.filter.division.id;
            }

            if (!this.$helper.isBlank(this.filter.kind)) {
                url += "filterKind=" + this.filter.kind.id;
            }

            if (!this.$helper.isBlank(this.filter.brand)) {
                url += "filterBrand=" + this.filter.brand.id;
            }

            this.$axios
                .get(url)
                .then(res => {
                    this.reportPath = res.data.data.path;
                    this.fetchReportStatus = 1;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                    this.fetchReportStatus = -1;
                })
                .finally(() => (this.isSubmitting = false));
        },

        downloadExcelStockSimple() {
            this.fetchReportStatus = 0;
            this.modalTitleDownload = "Download Excel Stock Simple";
            this.$bvModal.show("m-download-report");

            let param = this.processFilter();

            this.$axios
                .get("inventory/excel-stock-simple?" + param)
                .then(res => {
                    this.reportPath = res.data.data.path;
                    this.fetchReportStatus = 1;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                    this.fetchReportStatus = -1;
                })
                .finally(() => (this.isSubmitting = false));
        },

        downloadExcelAccessories() {
            this.fetchReportStatus = 0;
            this.modalTitleDownload = "Download Excel Inventaris Aksesoris";
            this.$bvModal.show("m-download-report");

            let url = "inventory/excel-inventory-accessories";

            let params = {
                filterDivision:
                    this.filter.division == null
                        ? null
                        : this.filter.division.id,
                filterKind:
                    this.filter.kind == null ? null : this.filter.kind.id,
                filterBrand:
                    this.filter.brand == null ? null : this.filter.brand.id,
                filterWarehouse:
                    this.filter.warehouse == null
                        ? null
                        : this.filter.warehouse.id,
                filterImeiSn:
                    this.filter.imeiSn === "" ? null : this.filter.imeiSn,
                filterNoFaktur:
                    this.filter.noFaktur === "" ? null : this.filter.noFaktur
            };

            this.$axios
                .get(url, { params })
                .then(res => {
                    this.reportPath = res.data.data.path;
                    this.fetchReportStatus = 1;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                    this.fetchReportStatus = -1;
                })
                .finally(() => (this.isSubmitting = false));
        },

        isMoveAllowed(item) {
            return [2, 4].includes(item.status); // Hanya READY atau RETUR
        },

        prepareMove(item) {
            this.activeItem = item;
            this.$bvModal.show("m-move");
        },

        getBarcodeMoveLink() {
            if (this.barcodeMoveType == "barcode") {
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeMoveLink}`;
            } else {
                return `${this.$BASE_PRINT_FILE_PATH}${
                    this.barcodeMoveLinkDamage
                }`;
            }
        },

        toggleBarcodeMoveType() {
            this.barcodeToggleCooldown = true;
            if (this.barcodeMoveType == "barcode")
                this.barcodeMoveType = "damage";
            else this.barcodeMoveType = "barcode";
            setTimeout(
                function() {
                    this.barcodeToggleCooldown = false;
                }.bind(this),
                2000
            );
        },

        promptMove() {
            let isConfirmed = confirm("Lakukan pemindahan?");
            if (!isConfirmed) return;

            if (this.input.warehouse == 0) {
                return this.$helper.toastError(
                    this,
                    "Mohon memilih gudang tujuan!"
                );
            }

            this.isSubmitting = true;
            let payload = {
                id: this.activeItem.id,
                warehouse_id: this.input.warehouse
            };

            this.$axios
                .post("inventory/move-warehouse", payload)
                .then(res => {
                    this.$bvModal.hide("m-move");
                    this.$helper.toastSuccess(
                        this,
                        "Barang berhasil dipindahkan!"
                    );

                    let data = res.data.data;
                    this.activeItem.warehouse = data.name;
                    this.barcodeMoveLink = data.link;
                    this.barcodeMoveLinkDamage = data.linkDamage;

                    this.$bvModal.show("m-barcode");
                    this.getItems(this.currentPage);
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        isResetAllowed(item) {
            return [2, 4].includes(item.status) && !item.is_public; // Hanya READY atau RETUR dan bukan item public (ecom)
        },

        prepareReset(item) {
            this.activeItem = item;
            this.isSubmitting = true;
            this.$axios
                .get(`inventory-variances/prefill/${item.id}?origin=RESET`)
                .then(res => {
                    this.resetDefaults = res.data.data;
                    this.$bvModal.show("m-data-perubahan-temuan-inventory");
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        // Gold never reaches this list (API excludes EMAS kinds), so no gold check here.
        prepareResetGrade(item) {
            this.activeItem = item;
            this.$bvModal.show("m-reset-grade");
        },

        isAdjustAllowed(item) {
            // return [2, 4, 7].includes(item.status) // Hanya READY, RETUR dan DRAFT
            // return [2, 4].includes(item.status) // Hanya READY dan RETUR
            return [2, 3, 4].includes(item.status); // Hanya READY, SOLD, dan RETUR
        },
        isFovidServiceCenterAllowed(item) {
            // return [2, 4, 7].includes(item.status) // Hanya READY, RETUR dan DRAFT
            return [2, 4].includes(item.status); // Hanya READY dan RETUR
            // return [2, 3, 4].includes(item.status) // Hanya READY, SOLD, dan RETUR
        },

        // diubah sementara supaya adjustment harga bisa diinput manual dulu
        // onChangeAdjustmentSelect(item, index){
        //     this.invoiceAdjustments[index].name = item.name
        //     this.invoiceAdjustments[index].adjustment = this.sanitizeString(item.adjustment)
        //     this.invoiceAdjustments[index].adjustmentPercentage = item.adjustment_percentage
        // },

        prepareColorUpdate(item) {
            this.activeItem = item;
            this.inputColor = null;
            if (item.color_id != null) {
                this.inputColor = {};
                this.inputColor.id = item.color_id;
                this.inputColor.name = item.color;
            }
            this.$bvModal.show("m-update-color");
        },

        confirmUpdateColor() {
            if (this.inputColor.id == null) {
                return this.$helper.toastError(
                    this,
                    "Warna barang tidak boleh kosong!"
                );
            }

            let payload = {
                id: this.activeItem.id,
                color: this.inputColor.id
            };

            this.isSubmitting = true;
            this.$axios
                .post("inventory/update-color", payload)
                .then(res => {
                    this.$helper.toastSuccess(
                        this,
                        "Update warna berhasil dilakukan!"
                    );
                    this.$bvModal.hide("m-update-color");
                    this.activeItem = {};
                    this.inputColor = {};
                    this.getItems(this.currentPage);
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        prepareAdjustment(item) {
            this.invoiceAdjustments = [];
            this.activeItem = item;
            this.isSubmitting = true;

            this.$axios
                .get(
                    "category/selection?item_kind_id=" + this.activeItem.kind_id
                )
                .then(res => {
                    this.optCategory = res.data.data.map(item => {
                        return {
                            value: item.id,
                            text: item.name
                        };
                    });

                    this.getInventoryAdjustment(item.id);
                    this.$bvModal.show("m-item-to-adjust");
                    this.isChangeAdjustment = false;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                    this.isSubmitting = false;
                });
        },

        getInventoryAdjustment(id) {
            let param = "?id=" + id;
            this.$axios
                .get("inventory/get-invoice-adjustments" + param)
                .then(res => {
                    this.invoiceAdjustments = res.data.data.map(item => {
                        let adjustmentObj = {
                            adjustment_id: item.adjustments_id,
                            name: item.adjustments_name,
                            adjustment: item.adjustment,
                            adjustmentPercentage: item.adjustment_percentage,
                            category_name: item.category_name,
                            hasAdjFormula: item.has_adj_formula,
                            is_increment: item.is_increment
                        };
                        return adjustmentObj;
                    });

                    for (let i = 0; i < this.invoiceAdjustments.length; i++) {
                        this.sanitize(this.invoiceAdjustments[i], true);
                    }
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        prepareAddAdjustment() {
            this.addAdj.optKind = [
                { value: this.activeItem.kind_id, text: this.activeItem.kind }
            ];
            this.addAdj.kind = this.activeItem.kind_id;
            this.addAdj.category = null;
            this.addAdj.optAdjustments = [];
            this.addAdj.name = null;
            if (this.activeItem.fixing_adjustment) {
                this.addAdj.adjustment = "0";
                this.addAdj.adjustmentPercentage = "";
            } else {
                this.addAdj.adjustment = "";
                this.addAdj.adjustmentPercentage = "";
            }
            this.$bvModal.show("m-add-adjustment");
        },

        confirmAddAdjustment() {
            if (this.$helper.isBlank(this.addAdj.name)) {
                this.$helper.toastError(
                    this,
                    "Data Keterangan Adjustment Kerusakan tidak boleh kosong !"
                );
                return;
            }

            if (
                this.$helper.isBlank(this.addAdj.adjustment) &&
                this.$helper.isBlank(this.addAdj.adjustmentPercentage)
            ) {
                if (!this.activeItem.fixing_adjustment) {
                    this.$helper.toastError(
                        this,
                        "Salah satu dari data Adjustment Nominal atau Persentase tidak boleh kosong !"
                    );
                    return;
                }
            }

            let payload = new FormData();

            payload.append("inventory_id", this.activeItem.id);
            payload.append("adjustment_id", this.addAdj.name);
            if (this.$helper.isBlank(this.addAdj.adjustmentPercentage)) {
                payload.append(
                    "adjustment",
                    this.$helper.toNumber(
                        this.addAdj.is_increment == 0
                            ? "-" + this.addAdj.adjustment
                            : this.addAdj.adjustment
                    )
                );
            } else {
                payload.append(
                    "adjustment",
                    parseInt(
                        (this.activeItem.final_price *
                            parseFloat(
                                this.addAdj.adjustmentPercentage
                                    .replace(",", ".")
                                    .replace(" ", "")
                            )) /
                            100
                    )
                );
                payload.append(
                    "adjustment_percentage",
                    Number(
                        parseFloat(
                            this.addAdj.adjustmentPercentage
                                .replace(",", ".")
                                .replace(" ", "")
                        )
                    ).toFixed(2)
                );
            }

            this.isSubmitting = true;
            this.$axios
                .post("inventory/add-invoice-adjustments", payload)
                .then(res => {
                    this.getInventoryAdjustment(this.activeItem.id);

                    this.$bvModal.hide("m-add-adjustment");
                    this.isChangeAdjustment = true;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                    this.isSubmitting = false;
                });
        },

        onChangeRowCategory(index) {
            this.invoiceAdjustments[index].name = "";
            this.invoiceAdjustments[index].adjustmentSelect = null;
            this.invoiceAdjustments[index].optAdjustments = [];
            if (
                !this.$helper.isBlank(this.invoiceAdjustments[index].category)
            ) {
                let param = "?item_kind_id=" + this.activeItem.kind_id;
                param +=
                    "&category_id=" + this.invoiceAdjustments[index].category;
                this.isSubmitting = true;
                this.$axios
                    .get("adjustment/selection-category" + param)
                    .then(res => {
                        this.invoiceAdjustments[
                            index
                        ].optAdjustments = res.data.data.map(item => {
                            return {
                                value: {
                                    id: item.id,
                                    name: item.name,
                                    adjustment: item.adjustment,
                                    adjustment_percentage:
                                        item.adjustment_percentage
                                },
                                text: item.name
                            };
                        });
                        this.isSubmitting = false;
                    });
            }
            this.isChangeAdjustment = true;
        },

        changeAdjustment() {
            this.isChangeAdjustment = true;
        },

        onChangeAdjCategory() {
            this.addAdj.name = null;
            this.addAdj.optAdjustments = [];
            this.addAdj.hasAdjustmentPrice = false;
            this.addAdj.adjustment = "";
            if (!this.$helper.isBlank(this.addAdj.category)) {
                let param = "?item_kind_id=" + this.activeItem.kind_id;
                param += "&category_id=" + this.addAdj.category;
                this.isSubmitting = true;
                this.$axios
                    .get("adjustment/selection-category" + param)
                    .then(res => {
                        this.addAdj.optAdjustments = res.data.data.map(item => {
                            return {
                                value: item.id,
                                text: item.name
                            };
                        });

                        this.addAdj.selectedCategoryAdjustments = res.data.data;
                        this.isSubmitting = false;
                    });
            }
        },

        onChangeNewAdjCategory() {
            this.editItemAdj.new_name = null;
            this.editItemAdj.new_optAdjustments = [];
            this.editItemAdj.new_hasAdjustmentPrice = false;
            this.editItemAdj.new_adjustment = "";
            if (!this.$helper.isBlank(this.editItemAdj.new_category)) {
                let param = "?item_kind_id=" + this.activeItem.kind_id;
                param += "&category_id=" + this.editItemAdj.new_category;
                this.isSubmitting = true;
                this.$axios
                    .get("adjustment/selection-category" + param)
                    .then(res => {
                        this.editItemAdj.new_optAdjustments = res.data.data.map(
                            item => {
                                return {
                                    value: item.id,
                                    text: item.name
                                };
                            }
                        );
                        this.editItemAdj.selectedCategoryAdjustments =
                            res.data.data;
                        this.isSubmitting = false;
                    })
                    .catch(error => this.$helper.parseError(this, error))
                    .finally(() => (this.isSubmitting = false));
            }
        },

        // addRow() {
        //     this.invoiceAdjustments.push({ name: "", adjustmentSelect: "", adjustment: "", adjustmentPercentage: "" })
        // },

        deleteRow(item) {
            const isConfirmed = confirm(
                "Apakah Anda yakin ingin menghapus data adjustment ini?"
            );
            if (!isConfirmed) return;

            const payload = {
                adjustment_id: item.adjustment_id,
                inventory_id: this.activeItem.id
            };

            this.isSubmitting = true;
            this.$axios
                .delete("inventory/delete-invoice-adjustment", {
                    data: payload
                })
                .then(() => {
                    this.$helper.toastSuccess(
                        this,
                        "Data Adjustment Berhasil Dihapus!"
                    );
                    this.getInventoryAdjustment(this.activeItem.id);
                    this.isChangeAdjustment = true;
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        editAdjustment(item) {
            if (item.hasAdjFormula) {
                this.editAdj.pendingSyncAdjustmentId = item.adjustment_id;
                this.$bvModal.show("m-sync-adjustment-confirm");
                return;
            }

            this.editAdj.adjustmentId = item.adjustment_id;
            this.editAdj.adjustment = "";
            this.editAdj.is_increment = item.is_increment;
            this.$bvModal.show("m-edit-adjustment");
        },

        syncAdjustmentPrice() {
            const payload = {
                inventory_id: this.activeItem.id,
                adjustment_id: this.editAdj.pendingSyncAdjustmentId
            };

            this.isSubmitting = true;
            this.$axios
                .patch("inventory/sync-adjustment-price", payload)
                .then(() => {
                    this.$helper.toastSuccess(
                        this,
                        "Harga Adjustment Berhasil Diupdate!"
                    );
                    this.getInventoryAdjustment(this.activeItem.id);
                    this.editAdj.pendingSyncAdjustmentId = null;
                    this.$bvModal.hide("m-sync-adjustment-confirm");
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        confirmEditAdjustment() {
            if (this.$helper.isBlank(this.editAdj.adjustment)) {
                this.$helper.toastError(
                    this,
                    "Data Adjustment Nominal tidak boleh kosong !"
                );
                return;
            }

            const payload = {
                adjustment_id: this.editAdj.adjustmentId,
                inventory_id: this.activeItem.id,
                adjustment: this.$helper.toNumber(
                    this.editAdj.is_increment == 0
                        ? "-" + this.editAdj.adjustment
                        : this.editAdj.adjustment
                )
            };

            this.isSubmitting = true;
            this.$axios
                .patch("inventory/edit-invoice-adjustment", payload)
                .then(() => {
                    this.$helper.toastSuccess(
                        this,
                        "Data Adjustment Berhasil Diupdate!"
                    );
                    this.getInventoryAdjustment(this.activeItem.id);
                    this.$bvModal.hide("m-edit-adjustment");
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        confirmAdd(id) {
            let confirmable = true;

            for (var i = 0; i < this.invoiceAdjustments.length; i++) {
                let adj = this.invoiceAdjustments[i];

                if (
                    this.$helper.isBlank(adj.adjustment) &&
                    this.$helper.isBlank(adj.adjustmentPercentage)
                ) {
                    confirmable = false;
                    return this.$helper.toastError(
                        this,
                        "Terdapat data adjustment yang kosong, mohon dilengkapi!"
                    );
                }
            }

            if (confirmable) {
                let payload = new FormData();
                let jsonData = {
                    adjInvoice: this.invoiceAdjustments.map(it => {
                        if (this.$helper.isBlank(it.adjustmentPercentage)) {
                            return {
                                name: it.name,
                                adjustment: this.$helper.toNumber(
                                    it.adjustment
                                ),
                                adjustmentPercentage: null,
                                adjustment_id: it.adjustment_id
                            };
                        } else {
                            return {
                                name: it.name,
                                adjustment: parseInt(
                                    (this.activeItem.final_price *
                                        parseFloat(
                                            it.adjustmentPercentage
                                                .replace(",", ".")
                                                .replace(" ", "")
                                        )) /
                                        100
                                ),
                                adjustmentPercentage: Number(
                                    parseFloat(
                                        it.adjustmentPercentage
                                            .replace(",", ".")
                                            .replace(" ", "")
                                    )
                                ).toFixed(2),
                                adjustment_id: it.adjustment_id
                            };
                        }
                    })
                };

                payload.append("data", JSON.stringify(jsonData));
                payload.append("id", id);
                payload.append("changed", this.isChangeAdjustment);

                this.isSubmitting = true;
                this.$axios
                    .post("inventory/update-invoice-adjustments", payload)
                    .then(res => {
                        this.$helper.toastSuccess(
                            this,
                            "Update Adjustment Berhasil!"
                        );
                        this.$bvModal.hide("m-item-to-adjust");
                        this.getItems(this.currentPage);
                    })
                    .catch(error => this.$helper.parseError(this, error))
                    .finally(() => (this.isSubmitting = false));
            }
        },

        editItemAdjustment(item) {
            this.editAdjustment.new_adjustment_id = null;
            this.editAdjustment.new_category = null;

            this.editItemAdj = {
                ...this.editItemAdj,
                ...item
            };

            this.$bvModal.show("m-edit-item-adjustments");
        },

        confirmEditItemAdjustment() {
            this.isSubmitting = true;

            const payload = {
                inventory_id: this.activeItem.id,
                prev_adjustment_id: this.editItemAdj.adjustment_id,
                new_adjustment_id: this.editItemAdj.new_adjustment_id
            };

            this.$axios
                .post("inventory/adjustment/change-after-sold", payload)
                .then(() => {
                    this.$helper.toastSuccess(
                        this,
                        "Data Adjustment Berhasil Diubah!"
                    );
                    this.getInventoryAdjustment(this.activeItem.id);
                    this.$bvModal.hide("m-edit-item-adjustments");
                    this.$bvModal.hide("m-item-to-adjust");

                    this.editAdjustment.new_adjustment_id = null;
                    this.editAdjustment.new_category = null;
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        sanitize(item, allowNegative = false) {
            let str = String(item.adjustment);
            let isNegative = str.startsWith("-");

            if (allowNegative && isNegative) {
                str = str.substring(1);
            }

            let cleaned = str.replace(/\./g, "");
            let res = cleaned
                .replace(/[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

            if (allowNegative && isNegative) {
                res = "-" + res;
            }

            item.adjustment = res;
            this.isChangeAdjustment = true;
        },

        sanitizeString(str) {
            let cleaned = String(str).replace(/\./g, "");
            let res = cleaned
                .replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            return res;
        },

        prepareImage(item, type) {
            this.mediaPreview = {};
            this.mediaList = [];
            this.prepareImageType = type;
            this.activeItem = item;
            this.isSubmitting = true;
            let param = "?id=" + item.id;
            if (type == "kerusakan") {
                this.$axios
                    .get("inventory-damaged-photo" + param)
                    .then(res => {
                        for (let i = 0; i < res.data.data.length; i++) {
                            let fileMedia = "";
                            let fileAltText = "";
                            if (
                                res.data.data[i].type == "image/jpeg" ||
                                res.data.data[i].type == "image/png"
                            ) {
                                fileMedia = "image";
                                fileAltText = "Upload Image Preview";
                            } else if (
                                res.data.data[i].type == "video/mp4" ||
                                res.data.data[i].type == "video/webm" ||
                                res.data.data[i].type == "video/ogg" ||
                                res.data.data[i].type == "video/3gpp"
                            ) {
                                fileMedia = "video";
                                fileAltText = "Upload Video Preview";
                            } else {
                                continue;
                            }
                            let filenameSplit = res.data.data[i].path.split(
                                "/"
                            );
                            filenameSplit = filenameSplit[
                                filenameSplit.length - 1
                            ].split(".");
                            let fileExtension = filenameSplit.pop();
                            let filename = filenameSplit.join();
                            this.mediaList.push({
                                id: res.data.data[i].id,
                                media: fileMedia,
                                type: res.data.data[i].type,
                                filename: filename,
                                extension: fileExtension,
                                url: res.data.data[i].path,
                                altText: fileAltText,
                                status: "get",
                                isActive: false,
                                file: null
                            });
                        }
                        this.isImageChanged = false;
                        this.$bvModal.show("m-image-old");
                    })
                    .catch(error => this.$helper.parseError(this, error))
                    .finally(() => (this.isSubmitting = false));
            } else if (type == "fisik") {
                this.$axios
                    .get("inventory-photo" + param)
                    .then(res => {
                        for (let i = 0; i < res.data.data.length; i++) {
                            let fileMedia = "image";
                            let fileAltText = "Upload Image Preview";
                            let filenameSplit = res.data.data[i].path.split(
                                "/"
                            );
                            filenameSplit = filenameSplit[
                                filenameSplit.length - 1
                            ].split(".");
                            let fileExtension = filenameSplit.pop();
                            let filename = filenameSplit.join();
                            let fileType = "";

                            if (
                                fileExtension == "jpg" ||
                                fileExtension == "jpeg" ||
                                fileExtension == "png"
                            ) {
                                fileMedia = "image";
                                fileType = `image/${fileExtension}`;
                                fileAltText = "Upload Image Preview";
                            } else if (
                                fileExtension == "mp4" ||
                                fileExtension == "webm" ||
                                fileExtension == "ogg" ||
                                fileExtension == "3gpp"
                            ) {
                                fileMedia = "video";
                                fileType = `video/${fileExtension}`;
                                fileAltText = "Upload Video Preview";
                            } else {
                                continue;
                            }

                            this.mediaList.push({
                                id: res.data.data[i].id,
                                media: fileMedia,
                                type: fileType,
                                filename: filename,
                                extension: fileExtension,
                                url: res.data.data[i].path,
                                urlCompress: res.data.data[i].path_compress,
                                title: res.data.data[i].category || "-",
                                altText: fileAltText,
                                status: "get",
                                isActive: false,
                                file: null
                            });
                        }
                        this.isImageChanged = false;
                        this.$bvModal.show("m-image-old");
                    })
                    .catch(error => this.$helper.parseError(this, error))
                    .finally(() => (this.isSubmitting = false));
            }
        },
        prepareFovidServiceCenter(item) {
            this.mediaPreview = {};
            this.mediaList = [];
            this.activeItem = item;
            this.isSubmitting = true;
            let param = "?inventory_id=" + item.id;

            this.$axios
                .get("inventory-service-attachment" + param)
                .then(res => {
                    for (let i = 0; i < res.data.data.length; i++) {
                        let fileMedia = "";
                        let fileAltText = "";
                        if (
                            res.data.data[i].type == "image/jpeg" ||
                            res.data.data[i].type == "image/png"
                        ) {
                            fileMedia = "image";
                            fileAltText = "Upload Image Preview";
                        } else if (
                            res.data.data[i].type == "video/mp4" ||
                            res.data.data[i].type == "video/webm" ||
                            res.data.data[i].type == "video/ogg" ||
                            res.data.data[i].type == "video/3gpp"
                        ) {
                            fileMedia = "video";
                            fileAltText = "Upload Video Preview";
                        } else {
                            continue;
                        }
                        let filenameSplit = res.data.data[i].path.split("/");
                        filenameSplit = filenameSplit[
                            filenameSplit.length - 1
                        ].split(".");
                        let fileExtension = filenameSplit.pop();
                        let filename = filenameSplit.join();
                        this.mediaList.push({
                            id: res.data.data[i].id,
                            media: fileMedia,
                            type: res.data.data[i].type,
                            filename: filename,
                            extension: fileExtension,
                            url: res.data.data[i].path,
                            altText: fileAltText,
                            status: "get",
                            isActive: false,
                            file: null
                        });
                    }
                    this.isImageChanged = false;
                    this.$bvModal.show("m-fovid-service-center-image");
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        prepareAdjImage(item) {
            this.activeAdjustmentRow = item;
            this.mediaPreview = {};
            this.mediaList = [];
            this.activeAdjustment = item.adjustment_id;
            this.isSubmitting = true;
            let param = "?inventory_id=" + this.activeItem.id;
            param += "&adjustment_id=" + this.activeAdjustment;
            this.$axios
                .get("adjustment-damaged-photo" + param)
                .then(res => {
                    for (let i = 0; i < res.data.data.length; i++) {
                        let fileMedia = "";
                        let fileAltText = "";
                        if (
                            res.data.data[i].type == "image/jpeg" ||
                            res.data.data[i].type == "image/png"
                        ) {
                            fileMedia = "image";
                            fileAltText = "Upload Image Preview";
                        } else if (
                            res.data.data[i].type == "video/mp4" ||
                            res.data.data[i].type == "video/webm" ||
                            res.data.data[i].type == "video/ogg" ||
                            res.data.data[i].type == "video/3gpp"
                        ) {
                            fileMedia = "video";
                            fileAltText = "Upload Video Preview";
                        } else {
                            continue;
                        }
                        let filenameSplit = res.data.data[i].path.split("/");
                        filenameSplit = filenameSplit[
                            filenameSplit.length - 1
                        ].split(".");
                        let fileExtension = filenameSplit.pop();
                        let filename = filenameSplit.join();
                        this.mediaList.push({
                            id: res.data.data[i].id,
                            media: fileMedia,
                            type: res.data.data[i].type,
                            filename: filename,
                            extension: fileExtension,
                            title: res.data.data[i].category
                                ? res.data.data[i].category.name
                                : "-",
                            url: res.data.data[i].path,
                            urlCompress: res.data.data[i].path_compress,
                            altText: fileAltText,
                            status: "get",
                            isActive: false,
                            file: null
                        });
                    }
                    this.isImageChanged = false;
                    this.$bvModal.show("m-image");
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        onClickImage(url) {
            for (let i = 0; i < this.mediaList.length; i++) {
                this.mediaList[i].isActive = false;
                if (this.mediaList[i].url == url) {
                    this.mediaList[i].isActive = true;
                    this.mediaPreview = lodash.cloneDeep(this.mediaList[i]);
                }
            }
        },

        onAddImage() {
            this.$refs.fileupload.click();
            this.isChangePhotoAdjustment = true;
        },

        onUploadImage(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            // else if(files[0].size > this.$uploadLimit) {
            //     return
            // }
            if (this.filterMediaList.length + files.length > 10) {
                this.$helper.toastError(
                    this,
                    "Operasi Upload Dibatalkan! Jumlah gambar / video melebihi kapasitas maksimal 10 item per inventori."
                );
                return;
            }
            for (let i = 0; i < files.length; i++) {
                let fileMedia = "";
                let fileAltText = "";
                if (
                    files[i].type == "image/jpeg" ||
                    files[i].type == "image/png"
                ) {
                    fileMedia = "image";
                    fileAltText = "Upload Image Preview";
                } else if (
                    files[i].type == "video/mp4" ||
                    files[i].type == "video/webm" ||
                    files[i].type == "video/ogg"
                ) {
                    fileMedia = "video";
                    fileAltText = "Upload Video Preview";
                } else {
                    this.$helper.toastError(
                        this,
                        "Upload Item Gagal! Jenis file " +
                            files[i].name +
                            " tidak dikenali oleh sistem."
                    );
                    continue;
                }
                let filenameSplit = files[i].name.split(".");
                let fileExtension = filenameSplit.pop();
                let filename = filenameSplit.join();
                let fileResult = {
                    id: null,
                    media: fileMedia,
                    type: files[i].type,
                    filename: filename,
                    extension: fileExtension,
                    url: URL.createObjectURL(files[i]),
                    altText: fileAltText,
                    status: "upload",
                    isActive: false,
                    file: files[i]
                };
                this.mediaList.push(fileResult);
                // for(let i = 0; i < this.mediaList.length; i++){
                //     this.mediaList[i].isActive = false
                // }
                // this.mediaPreview = lodash.cloneDeep(fileResult)
                this.isImageChanged = true;
                this.$helper.toastSuccess(
                    this,
                    "Upload " + files[i].name + " berhasil!"
                );
            }
            this.$refs.fileupload.value = null;
        },

        onOpenImage(url) {
            window.open(url, "_blank");
        },

        onDeleteImage(url) {
            for (let i = 0; i < this.mediaList.length; i++) {
                if (this.mediaList[i].url == url) {
                    if (this.mediaList[i].status == "get") {
                        this.mediaList[i].status = "delete";

                        let payload = new FormData();

                        payload.append("inventory_id", this.activeItem.id);
                        payload.append("id_photo", this.mediaList[i].id);

                        this.$axios
                            .post("adjustment-damaged-photo/delete", payload)
                            .then(_ => {
                                this.$helper.toastSuccess(
                                    this,
                                    "Hapus Gambar Berhasil!"
                                );
                                // this.$bvModal.hide("m-image")
                                if (this.isChangePhotoAdjustment) {
                                    this.isChangeAdjustment = true;
                                }
                            })
                            .catch(error =>
                                this.$helper.parseError(this, error)
                            );
                    } else {
                        this.mediaList.splice(i, 1);
                    }
                    this.isImageChanged = true;
                    break;
                }
            }
            this.mediaPreview = {};
            this.isChangePhotoAdjustment = true;
        },

        onDeleteImageFovidServiceCenter(url) {
            const haveFovidPermission =
                this.$helper.checkRoleNumber(
                    EnumPermissions.DELETE_FOVID_SERVICE.toString(),
                    localStorage.getItem("permissions")
                ) || localStorage.getItem("roleName").includes("Superadmin");
            if (!haveFovidPermission) {
                this.$helper.toastError(
                    this,
                    "Anda tidak memiliki akses untuk menghapus media di menu ini."
                );
                return;
            }

            for (let i = 0; i < this.mediaList.length; i++) {
                if (this.mediaList[i].url == url) {
                    if (this.mediaList[i].status == "get") {
                        this.mediaList[i].status = "delete";

                        this.$axios
                            .delete(
                                "/inventory-service-attachment/" +
                                    this.mediaList[i].id
                            )
                            .then(_ => {
                                this.$helper.toastSuccess(
                                    this,
                                    "Hapus Gambar Berhasil!"
                                );
                            })
                            .catch(error =>
                                this.$helper.parseError(this, error)
                            );
                    } else {
                        this.mediaList.splice(i, 1);
                    }
                    this.isImageChanged = true;
                    break;
                }
            }
            this.mediaPreview = {};
        },

        onSaveImageFisik(id) {
            if (this.filterMediaList.length > 10) {
                this.$helper.toastError(
                    this,
                    "Operasi Save Dibatalkan! Jumlah gambar melebihi kapasitas maksimal 10 item per inventori."
                );
                return;
            }

            this.isSubmitting = true;

            let payload = new FormData();

            let uploadData = this.mediaList.filter(
                item => item.status == "upload"
            );
            let deleteData = this.mediaList.filter(
                item => item.status == "delete"
            );

            let totalSize = 0;

            for (let i = 0; i < uploadData.length; i++) {
                totalSize += uploadData[i].file.size;
                if (totalSize > 419430400) {
                    this.$helper.toastError(
                        this,
                        "Operasi Save Dibatalkan! Total ukuran gambar melebihi kapasitas maksimal 400MB untuk sekali upload."
                    );
                    return;
                }
                payload.append("uploads[]", uploadData[i].file);
            }

            for (let i = 0; i < deleteData.length; i++) {
                payload.append("deletes[]", deleteData[i].id);
            }

            payload.append("inventory_id", this.activeItem.id);

            this.$axios
                .post("inventory-photo/update", payload)
                .then(_ => {
                    this.$helper.toastSuccess(
                        this,
                        "Update Gambar Fisik Berhasil!"
                    );
                    this.$bvModal.hide("m-image-old");
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        onCloseModalImage(e) {
            // if (this.isImageChanged) {
            //     let isConfirmed = confirm("Apakah anda yakin ingin menutup menu Gambar Kerusakan? Perubahan yang belum disimpan akan hilang.")
            //     if (!isConfirmed) e.preventDefault()
            // }
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            console.log("onPageChange", newPage);
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getItems();
        },

        parseStatus(status, index) {
            switch (status) {
                case 2:
                    return ["dark", "READY"][index];
                case 3:
                    return ["success", "TERJUAL"][index];
                case 4:
                    return ["warning", "RETUR"][index];
                case 5:
                    return ["danger", "HILANG"][index];
                case 14:
                    return ["primary", "DALAM PERJALANAN"][index];
                case 6:
                    return ["primary", "KIRIM BALIK PGI"][index];
                case 66:
                    return ["primary", "REQUEST KIRIM BALIK PGI"][index];
                case 7:
                    return ["light", "DRAFT"][index];
                case 55:
                    return ["dark", "REQUEST HILANG"][index];
                case 8:
                    return ["dark", "REQUEST RESET"][index];
                case 10:
                    return ["primary", "INVENTARIS"][index];
                case 11:
                    return ["primary", "REQUEST INVENTARIS"][index];
                case 9:
                    return ["primary", "REQUEST MOVE"][index];
                default:
                    return ["light", "-"][index];
            }
        },

        resetFilter() {
            this.filter = {
                name: "",
                kind: null,
                brand: null,
                itemYear: "",
                spec: null,
                warehouse: null,
                noFaktur: "",
                imeiSn: "",
                grade: [],
                isBatangan: -1,
                status: [],
                from: null,
                to: null,
                adjustment: []
            };

            this.getItems(this.currentPage);
        },

        processFilter() {
            let param = "";

            if (!this.$helper.isBlank(this.filter.name)) {
                param += "&filterName=" + this.filter.name;
            }

            if (this.filter.division != null) {
                param += "&filterDivision=" + this.filter.division.id;
            }

            if (this.filter.kind != null) {
                param += "&filterKind=" + this.filter.kind.id;
            }

            if (this.filter.brand != null) {
                param += "&filterBrand=" + this.filter.brand.id;
            }

            if (
                !this.$helper.isBlank(this.filter.itemYear) &&
                !isNaN(this.filter.itemYear)
            ) {
                param += "&filterItemYear=" + Number(this.filter.itemYear);
            }

            if (!this.$helper.isBlank(this.filter.noFaktur)) {
                param += "&filterNoFaktur=" + this.filter.noFaktur;
            }

            if (!this.$helper.isBlank(this.filter.imeiSn)) {
                param += "&filterImeiSn=" + this.filter.imeiSn;
            }

            if (!this.$helper.isBlank(this.filter.noFakturOriginal)) {
                param += "&filterNoFakturOri=" + this.filter.noFakturOriginal;
            }

            if (this.filter.status.length != 0) {
                param +=
                    "&filterStatus=" +
                    this.filter.status.map(it => it.id).join();
            }

            if (this.filter.grade.length != 0) {
                param +=
                    "&filterGrade=" + this.filter.grade.map(it => it.id).join();
            }

            if (this.filter.isBatangan != -1) {
                param += "&filterIsBatangan=" + this.filter.isBatangan;
            }

            if (this.filter.warehouse != null) {
                param += "&filterWarehouse=" + this.filter.warehouse.id;
            }

            if (this.filter.spec != null) {
                param += "&filterSpec=" + this.filter.spec.id;
            }

            if (this.filter.from != null) {
                param += "&filterFrom=" + this.filter.from;
            }

            if (this.filter.to != null) {
                param += "&filterTo=" + this.filter.to;
            }

            if (this.filter.adjustment && this.filter.adjustment.length != 0) {
                param +=
                    "&filterAdjustment=" +
                    this.filter.adjustment.map(it => it.id).join();
            }

            return param;
        },

        showModalFilter() {
            this.$bvModal.show("m-filter");
        },

        onRefreshImage() {
            this.prepareAdjImage(this.activeAdjustmentRow);
        },

        onRefreshImageFovidServiceCenter() {
            this.prepareFovidServiceCenter(this.activeItem);
        },

        copyToClipboard(text) {
            navigator.clipboard.writeText(text).then(
                () => {
                    this.$helper.toastSuccess(
                        this,
                        "Berhasil menyalin teks ke clipboard!"
                    );
                },
                () => {
                    this.$helper.toastError(
                        this,
                        "Gagal menyalin teks ke clipboard!"
                    );
                }
            );
        },
        async checkImgUrlStatus(url) {
            return new Promise(resolve => {
                const img = new Image();
                img.onload = () => resolve(true);
                img.onerror = () => resolve(false);
                img.src = url;
            });
        },
        async setImageSource(media) {
            this.$set(media, "computedImageUrl", "/img/image-loading.gif");

            let computedUrl;

            if (media.media === "video") {
                computedUrl = "/img/video-thumbnail.png";
            } else if (media.status === "upload") {
                computedUrl = media.url;
            } else {
                const urlCompress = media.urlCompress;
                const isUrlCompressAccessible = await this.checkImgUrlStatus(
                    urlCompress
                );
                computedUrl = isUrlCompressAccessible ? urlCompress : media.url;
            }

            this.$set(media, "computedImageUrl", computedUrl);
        },
        async getPresignedUrl(fileName, fileType, directoryPath) {
            this.uploadTimeStamp.startPresignedUrl = this.formatTime(
                new Date()
            );
            const response = await this.$axios.post("get-presigned-url", {
                file_name: fileName,
                file_type: fileType,
                reference_key: this.activeItem.no_faktur_pgi,
                directory_path: directoryPath
            });
            this.uploadTimeStamp.endPresignedUrl = this.formatTime(new Date());
            return response.data.data;
        },
        async uploadToS3(file, presignedUrl) {
            this.uploadTimeStamp.startUploadToS3 = this.formatTime(new Date());

            const response = await fetch(presignedUrl, {
                method: "PUT",
                body: file,
                headers: {
                    "Content-Type": file.type
                }
            });
            this.uploadTimeStamp.endUploadToS3 = this.formatTime(new Date());
            return response;
        },
        async uploadFileForAdjustment(event) {
            const files = Array.from(event.target.files); // Convert FileList to an array
            if (!files || files.length === 0) return;

            // Validate file types and sizes
            const allowedImageTypes = ["image/jpeg", "image/png"];
            const allowedVideoTypes = ["video/mp4", "video/quicktime"];
            const maxSize = 400 * 1024 * 1024; // 400MB
            let totalSize = 0;

            for (const file of files) {
                if (
                    !allowedImageTypes.includes(file.type) &&
                    !allowedVideoTypes.includes(file.type)
                ) {
                    this.$helper.toastError(
                        this,
                        "Jenis file tidak valid. Silakan unggah gambar (JPG, PNG) atau video (MP4, MOV)."
                    );
                    return;
                }
                totalSize += file.size;
                if (totalSize > maxSize) {
                    this.$helper.toastError(
                        this,
                        "Total ukuran file melebihi batas maksimal 400MB."
                    );
                    return;
                }
            }

            // Show loading state
            this.isShowLoadingOverlay = true;

            try {
                const payload = new FormData();
                for (const file of files) {
                    // Fetch presigned URL from the backend
                    const {
                        presigned_url,
                        file_path
                    } = await this.getPresignedUrl(
                        file.name,
                        file.type,
                        "adjdmgpht"
                    );

                    // Upload file to S3 using the presigned URL
                    await this.uploadToS3(file, presigned_url);

                    // Append file metadata to the payload
                    payload.append("url[]", file_path);
                    payload.append("fileName[]", file_path);
                }

                // Add inventory and adjustment IDs to the payload
                payload.append("inventory_id", this.activeItem.id);
                payload.append("adjustment_id", this.activeAdjustment);
                payload.append("upload_provider", "aws");

                this.uploadTimeStamp.startSaveFile = this.formatTime(
                    new Date()
                );

                // Send the payload to the backend
                await this.$axios.post(
                    "adjustment-damaged-photo/update",
                    payload
                );
                this.$helper.toastSuccess(
                    this,
                    "Gambar/video berhasil diunggah!"
                );

                this.uploadTimeStamp.endSaveFile = this.formatTime(new Date());
                this.$bvModal.hide("m-image");
            } catch (error) {
                console.error("Upload file", error);
                this.$helper.toastError(this, "Gagal mengunggah media");
            } finally {
                this.isShowLoadingOverlay = false;
                this.resetUploadTimestamp();
            }
        },
        async uploadFileForFovidServiceCenter(event) {
            const files = Array.from(event.target.files); // Convert FileList to an array
            if (!files || files.length === 0) return;

            // Validate file types and sizes
            const allowedImageTypes = ["image/jpeg", "image/png"];
            const allowedVideoTypes = ["video/mp4", "video/quicktime"];
            const maxSize = 400 * 1024 * 1024; // 400MB
            let totalSize = 0;

            for (const file of files) {
                if (
                    !allowedImageTypes.includes(file.type) &&
                    !allowedVideoTypes.includes(file.type)
                ) {
                    this.$helper.toastError(
                        this,
                        "Jenis file tidak valid. Silakan unggah gambar (JPG, PNG) atau video (MP4, MOV)."
                    );
                    return;
                }
                totalSize += file.size;
                if (totalSize > maxSize) {
                    this.$helper.toastError(
                        this,
                        "Total ukuran file melebihi batas maksimal 400MB."
                    );
                    return;
                }
            }

            // Show loading state
            this.isShowLoadingOverlay = true;

            try {
                let payload = {
                    inventory_id: this.activeItem.id,
                    attachments: []
                };
                for (const file of files) {
                    // Fetch presigned URL from the backend
                    const {
                        presigned_url,
                        file_path
                    } = await this.getPresignedUrl(
                        file.name,
                        file.type,
                        "invtrysvc"
                    );

                    // Upload file to S3 using the presigned URL
                    await this.uploadToS3(file, presigned_url);

                    // Append file metadata to the payload
                    payload.attachments.push({
                        file_name: file_path
                    });
                }

                this.uploadTimeStamp.startSaveFile = this.formatTime(
                    new Date()
                );

                // Send the payload to the backend
                await this.$axios.post("inventory-service-attachment", payload);
                this.$helper.toastSuccess(
                    this,
                    "Gambar/video berhasil diunggah!"
                );

                this.uploadTimeStamp.endSaveFile = this.formatTime(new Date());
                this.$bvModal.hide("m-fovid-service-center-image");
            } catch (error) {
                console.error("Upload file", error);
                this.$helper.toastError(this, "Gagal mengunggah media");
            } finally {
                this.isShowLoadingOverlay = false;
                this.resetUploadTimestamp();
            }
        },
        triggerFileInputForAdjustment() {
            this.$refs.fileInputAdjustment.click();
        },
        triggerFileInputForFovidServiceCenter() {
            const haveFovidPermission =
                this.$helper.checkRoleNumber(
                    EnumPermissions.INSERT_FOVID_SERVICE.toString(),
                    localStorage.getItem("permissions")
                ) || localStorage.getItem("roleName").includes("Superadmin");
            if (!haveFovidPermission) {
                this.$helper.toastError(
                    this,
                    "Anda tidak memiliki akses untuk mengunggah media di menu ini."
                );
                return;
            }
            this.$refs.fileInputFovidServiceCenter.click();
        },
        formatTime(date) {
            const hours = String(date.getHours()).padStart(2, "0");
            const minutes = String(date.getMinutes()).padStart(2, "0");
            const seconds = String(date.getSeconds()).padStart(2, "0");
            return `${hours}:${minutes}:${seconds}`;
        },
        resetUploadTimestamp() {
            this.uploadTimeStamp = {
                startPresignedUrl: null,
                endPresignedUrl: null,
                startUploadToS3: null,
                endUploadToS3: null,
                startSaveFile: null,
                endSaveFile: null
            };
        },
        async calculatedAdjustment() {
            this.isSubmitCalculate = true;

            const payload = {
                inventory_id: this.activeItem.id
            };
            try {
                const response = await this.$axios.post(
                    "adjustment/calculate",
                    payload
                );
                // Update the adjustments array with the price and percentage from the response
                if (response.data.success && response.data.data.adjustments) {
                    this.adjustmentPercentages = response.data.data.adjustments.map(
                        adj => {
                            return {
                                ...adj,
                                adjustment_price: this.formatCurrency(
                                    adj.adjustment_price
                                ),
                                current_adjustment_price: this.formatCurrency(
                                    adj.current_adjustment_price
                                )
                            };
                        }
                    );
                    this.totalAdjustmentPrice = this.formatCurrency(
                        response.data.data.total_adjustment_price
                    );
                }
                this.isSubmitCalculate = false;
                this.$bvModal.show("m-calculate-adjustment");
            } catch (error) {
                this.isSubmitCalculate = false;
                this.$helper.parseError(this, error);
            }
        },
        onCloseModalCalculate() {
            this.$bvModal.hide("m-calculate-adjustment");
        },
        formatCurrency(value) {
            if (this.$helper.isBlank(value)) {
                return "-";
            }
            const stringValue =
                typeof value === "number" ? value.toFixed(2) : value;
            let [integerPart, decimalPart = "00"] = stringValue.split(".");
            integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            decimalPart = decimalPart.padEnd(2, "0");

            return `${integerPart},${decimalPart}`;
        },
        onSelectAdjustment(e) {
            const selected = this.addAdj.selectedCategoryAdjustments.find(
                adj => adj.id === e
            );
            const adjPercentages = selected.adjustment_percentages;

            this.addAdj.is_increment = selected.is_increment;

            if (!adjPercentages) {
                this.addAdj.adjustment = "";
                this.addAdj.hasAdjustmentPrice = false;
                return;
            }

            const basePrice = this.activeItem.final_price;

            const adjustmentObj = adjPercentages.find(
                range => basePrice >= range.from && basePrice <= range.to
            );

            const adjustmentPrice = adjustmentObj
                ? adjustmentObj.nominal
                : null;

            if (adjustmentPrice === null) {
                this.addAdj.adjustment = "";
                this.addAdj.hasAdjustmentPrice = false;
                return;
            }

            // set default amount adjustment based on range
            let cleaned = String(adjustmentPrice).replace(/\./g, "");
            let res = cleaned
                .replace(/[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

            this.addAdj.adjustment = res;
            this.addAdj.hasAdjustmentPrice = true;
        },
        onSelectNewAdjustment(e) {
            const selected = this.editItemAdj.selectedCategoryAdjustments.find(
                adj => adj.id === e
            );
            const adjPercentages = selected.adjustment_percentages;

            this.editItemAdj.is_increment = selected.is_increment;

            if (!adjPercentages) {
                this.editItemAdj.new_adjustment = "";
                this.editItemAdj.new_hasAdjustmentPrice = false;
                return;
            }

            const basePrice = this.activeItem.final_price;

            const adjustmentObj = adjPercentages.find(
                range => basePrice >= range.from && basePrice <= range.to
            );

            const adjustmentPrice = adjustmentObj
                ? adjustmentObj.nominal
                : null;

            if (adjustmentPrice === null) {
                this.editItemAdj.new_adjustment = "";
                this.editItemAdj.new_hasAdjustmentPrice = false;
                return;
            }

            // set default amount adjustment based on range
            let cleaned = String(adjustmentPrice).replace(/\./g, "");
            let res = cleaned
                .replace(/[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

            this.editItemAdj.new_adjustment = res;
            this.editItemAdj.new_hasAdjustmentPrice = true;
        }
    },
    computed: {
        filterMediaList() {
            return this.mediaList.filter(item => item.status != "delete");
        },
        isShowSimulationAdjDamage() {
            return (
                this.$helper.checkRoleNumber(
                    EnumPermissions.SIMULASI_ADJUSTMENT_KERUSAKAN.toString(),
                    localStorage.getItem("permissions")
                ) || localStorage.getItem("roleName").includes("Superadmin")
            );
        },
        hasAddAdjInventoryPermission() {
            return (
                this.$helper.checkRoleNumber(
                    EnumPermissions.ADD_ADJ_INVENTORY.toString(),
                    localStorage.getItem("permissions")
                ) || localStorage.getItem("roleName").includes("Superadmin")
            );
        },
        hasDeleteAdjInventoryPermission() {
            return (
                this.$helper.checkRoleNumber(
                    EnumPermissions.DELETE_ADJUSTMENT_INVENTORY.toString(),
                    localStorage.getItem("permissions")
                ) || localStorage.getItem("roleName").includes("Superadmin")
            );
        },
        hasAddPhotoAdjPermission() {
            return (
                this.$helper.checkRoleNumber(
                    EnumPermissions.ADD_FOTO_ADJ.toString(),
                    localStorage.getItem("permissions")
                ) || localStorage.getItem("roleName").includes("Superadmin")
            );
        },
        hasDeletePhotoAdjPermission() {
            return (
                this.$helper.checkRoleNumber(
                    EnumPermissions.DELETE_FOTO_ADJ.toString(),
                    localStorage.getItem("permissions")
                ) || localStorage.getItem("roleName").includes("Superadmin")
            );
        },
        hasEditAdjPricePermission() {
            return (
                this.$helper.checkRoleNumber(
                    EnumPermissions.EDIT_ADJUSTMENT_PRICE.toString(),
                    localStorage.getItem("permissions")
                ) || localStorage.getItem("roleName").includes("Superadmin")
            );
        },
        hasEditAdjAfterSoldPermission() {
            return (
                this.$helper.checkRoleNumber(
                    EnumPermissions.EDIT_ADJUSTMENT_AFTER_SOLD.toString(),
                    localStorage.getItem("permissions")
                ) || localStorage.getItem("roleName").includes("Superadmin")
            );
        }
    },
    created() {
        // if (!this.$helper.isBlank(sessionStorage.getItem("listInventoryFilter"))) {
        //     this.filter = JSON.parse(sessionStorage.getItem("listInventoryFilter"))
        // }
        this.init();
        this.isDownloadExcelAllowed = this.$helper.isAllowed(
            this.$helper.PERM_DOWNLOAD_EXCEL_STOCK
        );
        this.isMoveInventoryAllowed = this.$helper.isAllowed(
            this.$helper.PERM_MOVE_INVENTORY
        );
        this.isRequestResetAllowed = this.$helper.isAllowed(
            this.$helper.PERM_REQUEST_RESET_INVENTORY
        );
    }
};
</script>

<style scoped>
p {
    margin: 0;
}

/deep/ .adjust-column-min {
    min-width: 200px;
}

.media-container {
    height: 0;
    padding-top: 56.25%;
    position: relative;
}

.media-preview {
    max-height: 100%;
    max-width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    object-fit: cover;
    background-color: #dee2e6;
    left: 50%;
    transform: translateX(-50%);
}

:not(:root):-webkit-full-screen {
    object-fit: contain !important;
}

.media-scroll {
    margin-top: 10px;
    height: 70px;
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    background-color: #dee2e6;
    white-space: nowrap;
}

.media-scroll-content {
    display: inline-block !important;
    height: 100%;
    width: 20%;
}

.media-scroll-preview.active {
    border: 5px solid #65c2e4;
}

.media-scroll-preview:hover {
    opacity: 0.5;
}

.media-scroll-preview {
    height: 100%;
    width: 100%;
    border: 5px solid #dee2e6;
    border-radius: 0.25rem;
    object-fit: cover;
    background-color: #dee2e6;
    cursor: pointer;
}

.border-responsive {
    margin-top: 10px;
    border-top: 1px solid #c8ced3;
}

.media-disclaimer {
    text-align: justify;
    text-justify: inter-word;
}

@media only screen and (min-width: 576px) {
    .media-scroll {
        height: 100px;
    }
}

@media only screen and (min-width: 992px) {
    .border-responsive {
        margin-top: 0px;
        border-top: none;
        border-left: 1px solid #c8ced3;
    }
}

@media only screen and (min-width: 1200px) {
    .media-scroll {
        height: 150px;
    }
}
</style>
